import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const ko: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "인용 스타일 목록을 찾을 수 없습니다",
    metaTitle: "{label}(으)로 시작하는 인용 스타일",
    metaDescription:
      "{label}(으)로 시작하는 Citation Style Language 스타일 {count}개를 살펴보세요. 스타일을 열면 실제 인용 예시와 무료 생성기를 볼 수 있습니다.",
    ogSubtitle: "전용 예시와 생성기가 있는 스타일 {count}개.",
    ogKind: "A–Z 목록",
    schemaName: "{label}(으)로 시작하는 인용 스타일",
    schemaDescription:
      "{label}(으)로 시작하는 Citation Style Language 스타일 {count}개의 알파벳순 목록.",
    breadcrumbStyles: "인용 스타일",
    heading: "{label}(으)로 시작하는 인용 스타일",
    intro:
      "CSL 카탈로그의 이 부분에 있는 스타일 {count}개를 모두 살펴보세요. 각 페이지에는 해당 스타일의 서식이 적용된 예시와 무료 인용 생성기가 있습니다.",
    navLabel: "A부터 Z까지 인용 스타일",
    listHeading: "{label}(으)로 시작하는 모든 스타일",
  },
  nav: {
    tools: "도구",
    guides: "가이드",
    styles: "모든 스타일",
    bibliography: "내 참고문헌",
    search: "검색",
    glossary: "용어집",
    home: "홈",
    menu: "메뉴",
  },

  home: {
    title: "무료 인용 생성기",
    subtitle: "2026년 기준 업데이트",
    intro:
      "DOI, URL, BibTeX 항목을 붙여넣거나 책을 검색하면 APA, MLA, 시카고, 밴쿠버, 하버드를 비롯한 수천 가지 스타일에 맞춰 정확하게 서식이 갖춰진 참고문헌을 만들어 드립니다. 완전 무료, 유료 구독 불필요, 가입 불필요.",
    browseAllStyles: "{count}개 인용 스타일 모두 보기 →",
    featuresHeading: "인용에 필요한 모든 것",
    featureStyles: "{count}개 스타일",
    featureStylesDetail: "APA, MLA, 시카고 등",
    featureBibliographies: "여러 개의 참고문헌 목록",
    featureBibliographiesDetail: "과제별로 정리",
    featureBookSearch: "도서 검색",
    featureBookSearchDetail: "제목이나 저자로",
    featureExport: "어디로든 내보내기",
    featureExportDetail: "BibTeX, Word, RIS, CSV",
    featureDarkMode: "다크 모드",
    featureDarkModeDetail: "눈이 편안합니다",
    featureNoSignup: "가입 불필요",
    featureNoSignupDetail: "언제나 무료, 유료 구독 불필요",
    aboutHeading: "학생과 연구자를 위한 무료 인용 생성기",
    aboutBody:
      "CitationEasy는 10,000가지가 넘는 학술 인용 스타일을 지원합니다. 심리학의 APA, 문학의 MLA, 역사학의 시카고, 의학 학술지의 밴쿠버까지 — 서식은 근사치가 아니라 해당 스타일의 공식 정의에서 그대로 가져옵니다.",
    howItWorksHeading: "이용 방법",
    howItWorksStep1:
      "DOI, URL, ISBN, PubMed ID, arXiv ID 또는 BibTeX 항목을 붙여넣으세요. 제목으로 책을 검색할 수도 있습니다.",
    howItWorksStep2:
      "인용 스타일을 고르세요. 입력하면 {count}개 전체에서 검색됩니다.",
    howItWorksStep3:
      "완성된 참고문헌을 복사하거나, 목록에 저장한 뒤 Word, BibTeX, RIS로 내보내세요.",
    privacyNote:
      "참고문헌 목록은 사용자의 브라우저에 저장됩니다. 계정이 필요 없고 서버로 전송되는 것도 없습니다.",
  },

  hubs: {
    toolsTitle: "무료 글쓰기·인용 도구",
    toolsIntro:
      "브라우저에서 바로 쓰는 {count}개 도구: 모든 자료 유형을 위한 인용 생성기, 단어·글자 수 세기, 가독성 평가, 서식 정리 도구와 변환기. 모두 무료이며 즉시 사용할 수 있습니다.",
    stylesTitle: "모든 인용 스타일 살펴보기",
    stylesIntro:
      "Citation Style Language 프로젝트의 {count}개 스타일 전체를 국가·주제·학문 분야로 검색하고 걸러 볼 수 있습니다.",
    guidesTitle: "인용과 학술 글쓰기 가이드",
    guidesIntro:
      "자료 유형별 인용 방법, 찾은 자료를 평가하는 법, 더 잘 쓰는 법에 관한 자세한 가이드.",
    howToCiteTitle: "어떤 자료든 인용하는 방법",
    howToCiteIntro:
      "흔히 쓰는 자료 유형과 주요 인용 스타일을 짝지은 단계별 안내 페이지로, 각각 실제 예시가 들어 있습니다.",
    faqTitle: "인용에 관한 자주 묻는 질문",
    faqIntro:
      "인용할 때 학생들이 실제로 궁금해하는 점에 대한 짧고 정확한 답변.",
    glossaryTitle: "인용 용어집",
    glossaryIntro:
      "스타일 안내서와 과제 지시문에 등장하는 용어를 쉬운 말로 풀어 설명합니다.",
    openHub: "열기",
  },

  styleLanding: {
    metaTitle: "무료 {style} 인용 생성기",
    metaDescription:
      "{style} 인용을 무료로 만드세요. DOI, URL, ISBN, BibTeX을 붙여넣으면 올바른 {style} 형식의 참고문헌과 본문 내 인용을 얻을 수 있습니다.",
    heading: "{style} 인용 생성기",
    intro:
      "책, 학술지 논문, 웹사이트에 대한 정확한 {style} 인용을 한 번의 클릭으로 만드세요. 무료이며 가입이 필요 없습니다.",
    aboutHeading: "{style} 소개",
    whenToUseHeading: "{style}을 사용하는 경우",
    factsHeading: "{style} 한눈에 보기",
    factEdition: "판",
    factSystem: "인용 방식",
    factInText: "본문 내 형식",
    factReferenceList: "목록 이름",
    factFields: "주로 쓰이는 분야",
    systemAuthorDate: "저자–연도",
    systemNumbered: "번호식",
    systemFootnotes: "각주식",
    howToHeading: "이 {style} 생성기 사용법",
    howToStep1:
      "위 입력란에 URL, DOI, ISBN 또는 BibTeX 항목을 붙여넣거나 제목으로 책을 검색하세요.",
    howToStep2:
      "이 페이지에서는 {style}이 이미 선택되어 있으므로 바로 만들 수 있습니다.",
    howToStep3:
      "결과를 문서에 복사하거나, 저장해 두었다가 나중에 목록 전체를 내보내세요.",
    relatedHeading: "{style} 관련 자료 더 보기",
    englishOnlyNote:
      "{style}에 대한 상세 가이드와 자료 유형별 예시는 영어로 제공됩니다.",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "인용 스타일을 찾을 수 없습니다",
    metaTitle: "{style} 인용 생성기 - 무료 {style} 형식",
    metaFormatAndFields:
      "{style} 스타일은 {fields}에서 사용되는 {format} 방식입니다.",
    metaFormatOnly: "{style} 스타일은 {format} 방식입니다.",
    metaFieldsOnly: "{style} 스타일은 {fields}에서 사용됩니다.",
    metaPromiseNote:
      "실제 {style} 각주 예시를 보고 무료로 나만의 인용을 만들어 보세요.",
    metaPromiseExamples:
      "학술지 논문, 책, 웹사이트에 대한 실제 {style} 인용 예시를 보고 무료로 나만의 인용을 만들어 보세요.",
    ogKindFormat: "{format} 방식",
    ogKindDefault: "인용 스타일",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "및",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription:
      "{name}에 해당하는 인용 스타일입니다. Citation Style Language 저장소에서 제공됩니다.",
    genericWhenUsed:
      "{name} 스타일을 사용하는 간행물에 투고하거나 인용할 때 사용합니다.",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "인류학",
    disciplineAstronomy: "천문학",
    disciplineBiology: "생물학",
    disciplineBotany: "식물학",
    disciplineChemistry: "화학",
    disciplineCommunications: "커뮤니케이션학",
    disciplineEngineering: "공학",
    disciplineGenericBase: "일반",
    disciplineGeography: "지리학",
    disciplineGeology: "지질학",
    disciplineHistory: "역사학",
    disciplineHumanities: "인문학",
    disciplineLaw: "법학",
    disciplineLinguistics: "언어학",
    disciplineLiterature: "문학",
    disciplineMath: "수학",
    disciplineMedicine: "의학",
    disciplinePhilosophy: "철학",
    disciplinePhysics: "물리학",
    disciplinePoliticalScience: "정치학",
    disciplinePsychology: "심리학",
    disciplineScience: "과학",
    disciplineSocialScience: "사회과학",
    disciplineSociology: "사회학",
    disciplineTheology: "신학",
    disciplineZoology: "동물학",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "본문 내 인용에 저자명과 연도를 표시하고, 참고문헌 목록은 저자 이름의 가나다순으로 정렬하는 저자–연도 방식",
    formatClassNumeric:
      "자료가 처음 인용된 순서대로 번호가 매겨지고, 본문 내 인용에 그 번호를 사용하는 번호식",
    formatClassNote:
      "인용이 본문의 괄호가 아니라 각주나 미주에 표시되는 각주식",
    formatClassLabel:
      "저자명과 연도로 구성한 축약형 표시를 본문 내 인용에 사용하는 라벨식",
    formatClassAuthor:
      "본문 내 인용에는 저자명만 표시하고 자세한 정보는 참고문헌 목록에 담는 저자 표시 방식",
    formatClassOther: "{format} 방식",
    breadcrumbStyles: "인용 스타일",
    internationalLabel: "국제",
    heading: "{style} 인용 생성기",
    intro:
      "책, 논문, 웹사이트에 대한 정확한 {style} 인용을 한 번의 클릭으로 만드세요.",
    examplesHeading: "{style} 인용 예시",
    examplesIntro: "같은 세 가지 자료를 {style} 형식으로 정리한 예시입니다:",
    examplesIntroWithFormat:
      "같은 세 가지 자료를 {style} 형식으로 정리한 예시입니다 ({format}):",
    examplesNoteOnlyIntro:
      "{style} 스타일은 각주식입니다: 참고문헌 목록이 없고, 모든 인용이 각주로 표시됩니다. 다음은 예시 학술지 논문을 {style} 형식으로 인용한 것입니다:",
    labelJournalArticle: "학술지 논문",
    labelBook: "도서",
    labelWebsite: "웹사이트",
    labelFootnote: "각주 (학술지 논문)",
    labelInText: "본문 내 인용 (학술지 논문)",
    aboutHeading: "{style} 소개",
    whenToUseLabel: "{style} 사용 시점:",
    commonInLabel: "주로 사용되는 지역:",
    subjectAreasLabel: "주제 분야:",
    formattingRulesLabel: "서식 규칙:",
    parentStylePrefix: "{style} 스타일은 상위 스타일인",
    parentStyleSuffix: "의 서식을 따릅니다.",
    howToHeading: "이 {style} 생성기 사용법",
    howToBody:
      '위 입력란에 DOI, 뉴스 기사나 웹페이지의 URL, 또는 BibTeX 원본을 붙여넣으세요. 제목이나 저자로 책을 검색해 ISBN으로 인용할 수도 있습니다. 스타일 드롭다운에서 "{style}" 항목을 선택하고 (이 페이지에서는 이미 선택되어 있습니다) "인용 만들기"를 클릭하세요. 결과를 참고문헌 목록이나 참고문헌에 복사하세요. 복사하기 전에 생성된 인용을 편집할 수 있습니다 (예: 제목 수정이나 날짜 추가).',
    faqHeading: "{style}에 관한 자주 묻는 질문",
    faqWhatIsQ: "{style} 스타일이란 무엇인가요?",
    faqWhenQ: "{style} 스타일은 언제 사용해야 하나요?",
    faqInTextQ: "{style}에서 본문 내 인용은 어떤 모습인가요?",
    faqInTextA:
      "{style} 스타일은 {format}입니다. 예시 학술지 논문을 본문에서 인용하면 다음과 같습니다: {example}",
    faqReferenceQ: "{style} 참고문헌 목록 항목은 어떤 모습인가요?",
    faqReferenceA:
      "{style} 형식으로 정리한 학술지 논문은 다음과 같습니다: {example}",
    faqWhereQ: "{style} 스타일은 주로 어디에서 사용되나요?",
    faqWhereA: "{style} 스타일은 {region}에서 사용됩니다. {whenUsed}",
    faqRegionDefault: "전 세계",
    faqGenerateQ: "{style} 인용을 어떻게 만들 수 있나요?",
    faqGenerateA:
      '이 페이지의 무료 생성기를 이용하세요: DOI, URL(예: 뉴스 기사), 또는 BibTeX을 붙여넣거나 제목이나 저자로 책을 검색하세요. {style} 스타일을 선택하고 "인용 만들기"를 클릭하면 논문이나 참고문헌에 복사할 수 있는 서식이 적용된 참고문헌을 얻을 수 있습니다.',
    footerSupports:
      "는 전 세계 수많은 인용 스타일을 지원합니다. 저희 생성기는 Citation Style Language (CSL) 스타일을 사용합니다. 출처:",
    footerRepoLink: "공식 CSL 저장소",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "이 인용 만들기",
    generateBody:
      "URL, DOI, ISBN 또는 출처 정보를 붙여넣으면 {source}에 대한 {style} 인용이 바로 완성됩니다.",
    generateCta: "{tool} 열기 →",
    guideHeading: "더 알아보기",
    guideCta: "전체 가이드 읽기: {guide}",
    howToCiteHeading: "각 스타일로 {source} 인용하는 방법",
    howToCiteBody: "가장 많이 요구되는 스타일의 서식 규칙, 템플릿, 작성 예시.",
    howToCiteMore: "모든 출처 유형과 스타일 →",
    citeNowHeading: "{style}로 {source} 지금 인용하기",
    citeNowHowTo: "서식 규칙과 작성 예시",
    citeNowTool: "{tool}(으)로 만들기",
    citeNowHub: "{style} 인용 생성기",
    hubSourcesHeading: "{style}로 자주 쓰는 출처 인용하는 방법",
    hubGuidesHeading: "{style} 가이드",
    hubCompareHeading: "{style}과(와) 다른 스타일 비교",
    moreInCollection: "{collection}의 다른 도구",
    seeAllInCollection: "{collection} 전체 보기",
  },

  howToCitePage: {
    notFoundTitle: "찾을 수 없음",
    title: "{source} 인용법 ({style} {edition})",
    metaTitle: "{source} 인용법 ({style} {edition}, 2026년 업데이트)",
    metaDescription:
      "다음 자료를 {style} 형식으로 ({edition} 기준) 인용하는 방법을 알아보세요: {description}. 무료 예시, 템플릿, 본문 내 인용 가이드를 제공합니다.",
    keywordCite: "{source} {style} 인용법",
    keywordCitation: "{style} {source} 인용",
    keywordHowTo: "{source} 인용하는 법",
    keywordExample: "{style} 인용 예시",
    keywordReference: "{source} 참고문헌 {style}",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "인용문헌",
    refListWorksCitedPage: "인용문헌 페이지",
    refListBibliography: "서지 목록",
    refListBibliographyLower: "서지 목록",
    refListReferenceList: "참고문헌 목록",
    refListReferenceListLower: "참고문헌 목록",
    backLink: "← 모든 인용 가이드",
    lead: "다음 자료를 {style} 형식으로 ({edition} 기준) 인용하는 방법을 알아보세요: {description}. 이 가이드는 참고문헌 목록 형식, 본문 내 인용 예시, 핵심 서식 규칙을 다룹니다.",
    referenceFormatHeading: "{style} {list} 형식",
    referenceFormatIntro:
      "다음은 {list}에서 {source} 인용에 사용하는 표준 {style} 형식입니다:",
    noTemplateNote: "이 자료 유형에는 표준 {style} 서식을 따르세요.",
    workedHeading: "{style} {source} 인용 예시",
    workedIntro:
      "{source}에 대한 완전한 {style} 참고문헌으로, 공식 {style} CSL 스타일 정의로 생성했습니다 — 이 사이트의 생성기를 구동하는 것과 같은 엔진입니다:",
    workedNoteOnlyIntro:
      "{style} 스타일에서는 {source} 인용을 {list}에 넣지 않고 주석으로만 인용합니다. 다음은 공식 {style} CSL 스타일 정의로 생성한 그 주석입니다:",
    workedOscolaNote:
      "이 사이트가 생성하는 OSCOLA 출력은 제4판 CSL 스타일을 따른다. Citation Style Language 저장소에 제5판 CSL 스타일이 아직 공개되지 않았기 때문이다. 직접 고쳐야 한다: 모든 ibid를 축약 이름과 (n X)로 바꾸고, 제5판의 법원 식별자를 쓰고, 법률의 축약형을 작은따옴표 안에 쓰고, 열람일보다 영구 링크나 DOI를 우선한다",
    workedCheckedIntro:
      "{source}에 대한 완전한 {style} 참고문헌으로, 직접 작성한 뒤 이 자료에 대한 공식 {style} 지침과 대조해 확인했습니다:",
    workedCheckedNoteOnlyIntro:
      "{style} 스타일에서는 {source} 인용을 {list}에 넣지 않고 주석으로만 인용합니다. 다음은 직접 작성한 뒤 공식 {style} 지침과 대조해 확인한 그 주석입니다:",
    workedInTextLabel: "일치하는 본문 내 인용:",
    inTextHeading: "{style} 본문 내 인용",
    inTextIntro: "논문에서 이 자료를 인용할 때 다음 형식 중 하나를 사용하세요:",
    inTextParenthetical: "괄호 인용",
    inTextNarrative: "서술형 인용",
    rulesHeading: "{style} 핵심 서식 규칙",
    stepsHeading: "단계별 안내",
    step1Label: "자료 정보 수집:",
    step1Body:
      "{source} 인용에 필요한 저자명, 제목, 발행일, URL 또는 DOI를 모으세요.",
    step2Label: "참고문헌 서식 적용:",
    step2Body: "위에 나온 {style} ({edition}) 서식에 따라 요소를 배열하세요.",
    step3Label: "본문 내 인용 작성:",
    step3Body:
      "이 자료를 언급하는 곳에 괄호 인용이나 서술형 인용을 추가하세요.",
    step4Label: "{list}에 추가:",
    step4Body: "논문 끝에 서식이 적용된 전체 인용을 포함하세요.",
    step5Label: "서식 다시 확인:",
    step5Body:
      "기울임체, 구두점, 대소문자 표기, 내어쓰기가 {style} 요건에 맞는지 확인하세요.",
    ctaHeading: "이 인용 자동으로 만들기",
    ctaBody:
      "수동 서식 작업은 건너뛰세요. CitationEasy에 DOI, URL 또는 ISBN을 붙여넣으면 몇 초 만에 완벽하게 서식이 적용된 {style} 인용을 얻을 수 있습니다.",
    ctaButton: "지금 {style} 형식으로 인용하기 →",
    otherStylesHeading: "다른 스타일로 {source} 인용하기",
    comboLink: "{style} {source}",
    otherSourcesHeading: "{style} 형식으로 다른 자료 인용하기",
    resourcesHeading: "추가 자료",
    resourceGenerator: "무료 인용 생성기 ({count}개 스타일)",
    resourceTools: "무료 글쓰기 도구",
    resourceCompare: "인용 스타일 비교",
    resourceGuides: "모든 인용 가이드",
    resourceCheatSheets: "치트시트 (APA, MLA, Chicago)",
    resourceGlossary: "인용 용어집 (et al., ibid., DOI, 내어쓰기)",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "자료 정보 수집",
    schemaStep1Text:
      "{source}에 필요한 모든 정보(저자, 제목, 날짜, URL 또는 DOI)를 모으세요.",
    schemaStep2Name: "{style} 서식 적용",
    schemaStep2Text:
      "{style} ({edition}) 서식 규칙에 따라 인용 요소를 올바른 순서로 배열하세요.",
    schemaStep3Name: "본문 내 인용 작성",
    schemaStep3Text:
      "{style} 형식을 사용해 논문에 해당하는 본문 내 인용을 추가하세요.",
    schemaStep4Name: "참고문헌 목록에 추가",
    schemaStep4Text: "논문 끝에 있는 {list}에 전체 인용을 포함하세요.",
    faqHowQ: "{style}에서 {source} 인용은 어떻게 하나요?",
    faqHowA:
      "{style} 형식({edition} 기준)으로 {source} 인용을 작성하려면 저자, 제목, 날짜, 자료 위치를 포함하세요. 자동 서식 적용을 원하면 저희 무료 인용 생성기를 이용하세요.",
    faqFormatQ: "{source} 인용을 위한 {style} 형식은 무엇인가요?",
    faqFormatA: "{source} 인용의 {style} 형식은 다음과 같습니다: {example}",
    faqFormatFallback:
      "{style} 형식에는 저자, 제목, 날짜, 자료 위치 같은 특정 요소를 정해진 순서로 배열해야 합니다.",
    faqInTextQ: "{style}에서 {source} 본문 내 인용은 어떻게 표시되나요?",
    faqInTextA:
      "{style}에서 위 예시의 본문 내 인용은 다음과 같습니다: {example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Korean: no articles and no case. Every form is the bare noun phrase; templates append an invariant head noun (인용) or a postposition (에 대한, 의) and never an 을(를)-type particle on {source}.
  howToCiteSources: {
    websiteName: "웹사이트",
    websiteTitle: "웹사이트",
    websitePhrase: "웹사이트",
    websiteNoun: "웹사이트",
    websiteDescription: "웹페이지, 온라인 기사, 웹 콘텐츠",

    bookName: "도서",
    bookTitle: "도서",
    bookPhrase: "도서",
    bookNoun: "도서",
    bookDescription: "인쇄본 및 전자책",

    journalArticleName: "학술지 논문",
    journalArticleTitle: "학술지 논문",
    journalArticlePhrase: "학술지 논문",
    journalArticleNoun: "학술지 논문",
    journalArticleDescription: "동료 심사를 거친 학술 논문",

    youtubeVideoName: "YouTube 동영상",
    youtubeVideoTitle: "YouTube 동영상",
    youtubeVideoPhrase: "YouTube 동영상",
    youtubeVideoNoun: "YouTube 동영상",
    youtubeVideoDescription: "YouTube 및 온라인 동영상",

    podcastName: "팟캐스트",
    podcastTitle: "팟캐스트",
    podcastPhrase: "팟캐스트",
    podcastNoun: "팟캐스트",
    podcastDescription: "팟캐스트 에피소드와 시리즈",

    newspaperArticleName: "신문 기사",
    newspaperArticleTitle: "신문 기사",
    newspaperArticlePhrase: "신문 기사",
    newspaperArticleNoun: "신문 기사",
    newspaperArticleDescription: "인쇄 및 온라인 신문 기사",

    magazineArticleName: "잡지 기사",
    magazineArticleTitle: "잡지 기사",
    magazineArticlePhrase: "잡지 기사",
    magazineArticleNoun: "잡지 기사",
    magazineArticleDescription: "인쇄 및 온라인 잡지 기사",

    blogPostName: "블로그 게시물",
    blogPostTitle: "블로그 게시물",
    blogPostPhrase: "블로그 게시물",
    blogPostNoun: "블로그 게시물",
    blogPostDescription: "블로그 게시물과 온라인 칼럼",

    wikipediaName: "Wikipedia",
    wikipediaTitle: "Wikipedia",
    wikipediaPhrase: "Wikipedia",
    wikipediaNoun: "Wikipedia",
    wikipediaDescription: "Wikipedia 문서와 위키 항목",

    pdfName: "PDF",
    pdfTitle: "PDF",
    pdfPhrase: "PDF",
    pdfNoun: "PDF",
    pdfDescription: "PDF 문서와 보고서",

    interviewName: "인터뷰",
    interviewTitle: "인터뷰",
    interviewPhrase: "인터뷰",
    interviewNoun: "인터뷰",
    interviewDescription: "개인 인터뷰, 출판된 인터뷰, 방송 인터뷰",

    socialMediaName: "소셜 미디어 게시물",
    socialMediaTitle: "소셜 미디어 게시물",
    socialMediaPhrase: "소셜 미디어 게시물",
    socialMediaNoun: "소셜 미디어 게시물",
    socialMediaDescription:
      "트윗, Instagram 게시물, Facebook 게시물, TikTok 영상",

    governmentDocumentName: "정부 문서",
    governmentDocumentTitle: "정부 문서",
    governmentDocumentPhrase: "정부 문서",
    governmentDocumentNoun: "정부 문서",
    governmentDocumentDescription: "정부 보고서, 법령, 공식 문서",

    dissertationName: "학위논문",
    dissertationTitle: "학위논문",
    dissertationPhrase: "학위논문",
    dissertationNoun: "학위논문",
    dissertationDescription: "박사 학위논문과 석사 학위논문",

    conferencePaperName: "학술대회 논문",
    conferencePaperTitle: "학술대회 논문",
    conferencePaperPhrase: "학술대회 논문",
    conferencePaperNoun: "학술대회 논문",
    conferencePaperDescription: "학술대회 논문집과 발표 자료",

    lectureNotesName: "강의 또는 PowerPoint",
    lectureNotesTitle: "강의 또는 PowerPoint",
    lectureNotesPhrase: "강의 또는 PowerPoint",
    lectureNotesNoun: "강의 또는 PowerPoint",
    lectureNotesDescription: "수업 강의, 슬라이드, 강의 자료",

    webinarName: "웨비나",
    webinarTitle: "웨비나",
    webinarPhrase: "웨비나",
    webinarNoun: "웨비나",
    webinarDescription: "실시간 및 녹화된 온라인 웨비나와 웹 세미나",

    onlineCourseName: "온라인 강좌",
    onlineCourseTitle: "온라인 강좌",
    onlineCoursePhrase: "온라인 강좌",
    onlineCourseNoun: "온라인 강좌",
    onlineCourseDescription:
      "온라인 강좌와 MOOC(Coursera, edX, Udemy, FutureLearn)",

    presentationSlidesName: "PowerPoint 프레젠테이션",
    presentationSlidesTitle: "PowerPoint 프레젠테이션",
    presentationSlidesPhrase: "PowerPoint 프레젠테이션",
    presentationSlidesNoun: "PowerPoint 프레젠테이션",
    presentationSlidesDescription: "PowerPoint 및 발표용 슬라이드",

    imageName: "이미지 또는 사진",
    imageTitle: "이미지 또는 사진",
    imagePhrase: "이미지 또는 사진",
    imageNoun: "이미지 또는 사진",
    imageDescription: "사진, 미술 작품, 도표, 온라인 이미지",

    movieName: "영화",
    movieTitle: "영화",
    moviePhrase: "영화",
    movieNoun: "영화",
    movieDescription: "영화 작품",

    documentaryName: "다큐멘터리",
    documentaryTitle: "다큐멘터리",
    documentaryPhrase: "다큐멘터리",
    documentaryNoun: "다큐멘터리",
    documentaryDescription: "다큐멘터리 영화와 논픽션 영화",

    tvShowName: "TV 프로그램",
    tvShowTitle: "TV 프로그램",
    tvShowPhrase: "TV 프로그램",
    tvShowNoun: "TV 프로그램",
    tvShowDescription: "TV 프로그램 및 시리즈",

    songName: "노래 또는 음악",
    songTitle: "노래 또는 음악",
    songPhrase: "노래 또는 음악",
    songNoun: "노래 또는 음악",
    songDescription: "노래 및 음악 녹음물",

    poemName: "시",
    poemTitle: "시",
    poemPhrase: "시",
    poemNoun: "시",
    poemDescription: "선집이나 모음집에 실린 시와 운문",

    courtCaseName: "법원 판례",
    courtCaseTitle: "법원 판례",
    courtCasePhrase: "법원 판례",
    courtCaseNoun: "법원 판례",
    courtCaseDescription: "법원 판례와 법적 판결",

    patentName: "특허",
    patentTitle: "특허",
    patentPhrase: "특허",
    patentNoun: "특허",
    patentDescription: "특허 및 지식재산권 출원 문서",

    encyclopediaName: "백과사전 항목",
    encyclopediaTitle: "백과사전 항목",
    encyclopediaPhrase: "백과사전 항목",
    encyclopediaNoun: "백과사전 항목",
    encyclopediaDescription: "백과사전 문서 및 항목",

    dictionaryName: "사전 항목",
    dictionaryTitle: "사전 항목",
    dictionaryPhrase: "사전 항목",
    dictionaryNoun: "사전 항목",
    dictionaryDescription: "사전의 뜻풀이 및 표제어",

    datasetName: "데이터셋",
    datasetTitle: "데이터셋",
    datasetPhrase: "데이터셋",
    datasetNoun: "데이터셋",
    datasetDescription: "데이터셋 및 데이터베이스",

    softwareName: "소프트웨어 또는 앱",
    softwareTitle: "소프트웨어 또는 앱",
    softwarePhrase: "소프트웨어 또는 앱",
    softwareNoun: "소프트웨어 또는 앱",
    softwareDescription: "소프트웨어, 앱, 컴퓨터 프로그램",

    videoGameName: "비디오 게임",
    videoGameTitle: "비디오 게임",
    videoGamePhrase: "비디오 게임",
    videoGameNoun: "비디오 게임",
    videoGameDescription: "비디오 게임과 인터랙티브 게임 소프트웨어",

    pressReleaseName: "보도자료",
    pressReleaseTitle: "보도자료",
    pressReleasePhrase: "보도자료",
    pressReleaseNoun: "보도자료",
    pressReleaseDescription: "보도자료 및 뉴스 릴리스",

    reportName: "보고서",
    reportTitle: "보고서",
    reportPhrase: "보고서",
    reportNoun: "보고서",
    reportDescription: "보고서 및 백서",

    preprintName: "프리프린트",
    preprintTitle: "프리프린트",
    preprintPhrase: "프리프린트",
    preprintNoun: "프리프린트",
    preprintDescription: "arXiv, bioRxiv 등 프리프린트 서버의 논문",

    bookChapterName: "도서의 장",
    bookChapterTitle: "도서의 장",
    bookChapterPhrase: "도서의 장",
    bookChapterNoun: "도서의 장",
    bookChapterDescription: "편저 도서에 수록된 장과 에세이",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "ChatGPT",
    chatgptDescription: "ChatGPT 및 기타 생성형 AI 도구",

    bibleName: "성경",
    bibleTitle: "성경",
    biblePhrase: "성경",
    bibleNoun: "성경",
    bibleDescription: "성경, 경전, 기타 성스러운 문헌",

    tedTalkName: "TED 강연",
    tedTalkTitle: "TED 강연",
    tedTalkPhrase: "TED 강연",
    tedTalkNoun: "TED 강연",
    tedTalkDescription: "TED 강연과 녹화된 학술대회 강연",

    emailName: "이메일",
    emailTitle: "이메일",
    emailPhrase: "이메일",
    emailNoun: "이메일",
    emailDescription: "이메일, 편지, 개인 간 통신",

    redditName: "Reddit 또는 포럼 게시물",
    redditTitle: "Reddit 또는 포럼 게시물",
    redditPhrase: "Reddit 또는 포럼 게시물",
    redditNoun: "Reddit 또는 포럼 게시물",
    redditDescription: "Reddit 스레드, AMA, 온라인 포럼 및 토론 게시판 게시물",

    tweetName: "X (Twitter) 게시물",
    tweetTitle: "X (Twitter) 게시물",
    tweetPhrase: "X (Twitter) 게시물",
    tweetNoun: "X (Twitter) 게시물",
    tweetDescription: "트윗과 X(구 Twitter) 게시물",

    mapName: "지도",
    mapTitle: "지도",
    mapPhrase: "지도",
    mapNoun: "지도",
    mapDescription: "인쇄 지도, 지도책, Google Maps 같은 동적 지도",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "Claude",
    claudeDescription: "Claude 대화 및 기타 Anthropic AI 출력물",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "Gemini",
    geminiDescription: "Google Gemini 대화 및 AI 출력물",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "Microsoft Copilot",
    copilotDescription: "Microsoft Copilot 대화 및 AI 답변",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "Perplexity",
    perplexityDescription: "Perplexity AI 답변, 스레드 및 인용된 출처",

    aiImageName: "AI 생성 이미지",
    aiImageTitle: "AI 생성 이미지",
    aiImagePhrase: "AI 생성 이미지",
    aiImageNoun: "AI 생성 이미지",
    aiImageDescription: "DALL·E, Midjourney, Gemini 등 AI 도구로 만든 이미지",

    tiktokName: "TikTok 동영상",
    tiktokTitle: "TikTok 동영상",
    tiktokPhrase: "TikTok 동영상",
    tiktokNoun: "TikTok 동영상",
    tiktokDescription: "TikTok 동영상과 크리에이터 게시물",

    instagramName: "Instagram 게시물",
    instagramTitle: "Instagram 게시물",
    instagramPhrase: "Instagram 게시물",
    instagramNoun: "Instagram 게시물",
    instagramDescription: "Instagram 게시물, 릴스, 스토리",

    statuteName: "법률 또는 법령",
    statuteTitle: "법률 또는 법령",
    statutePhrase: "법률 또는 법령",
    statuteNoun: "법률 또는 법령",
    statuteDescription: "입법부가 제정한 법률, 법령, 성문화된 법전",

    isoStandardName: "ISO 표준",
    isoStandardTitle: "ISO 표준",
    isoStandardPhrase: "ISO 표준",
    isoStandardNoun: "ISO 표준",
    isoStandardDescription: "ISO, IEC 및 기타 발행된 기술 표준",

    quranName: "꾸란",
    quranTitle: "꾸란",
    quranPhrase: "꾸란",
    quranNoun: "꾸란",
    quranDescription: "아랍어 원문 또는 번역본 꾸란",

    ebookNoPageNumbersName: "페이지 번호가 없는 전자책",
    ebookNoPageNumbersTitle: "페이지 번호가 없는 전자책",
    ebookNoPageNumbersPhrase: "페이지 번호가 없는 전자책",
    ebookNoPageNumbersNoun: "페이지 번호가 없는 전자책",
    ebookNoPageNumbersDescription:
      "고정된 페이지 번호가 없는 Kindle, EPUB, 온라인 전자책",

    speechName: "연설",
    speechTitle: "연설",
    speechPhrase: "연설",
    speechNoun: "연설",
    speechDescription: "현장 또는 녹화된 연설, 강연, 설교",

    letterName: "서신",
    letterTitle: "서신",
    letterPhrase: "서신",
    letterNoun: "서신",
    letterDescription: "출판된 서신, 기록보관소 소장 서신, 공개서한",

    secondarySourceName: "2차 자료(재인용)",
    secondarySourceTitle: "2차 자료(재인용)",
    secondarySourcePhrase: "2차 자료(재인용)",
    secondarySourceNoun: "2차 자료",
    secondarySourceDescription:
      "다른 저작에서 인용되거나 언급된 것을 보고 찾은 자료",
  },

  // ---------------------------------------------------------------------------
  // NOT YET TRANSLATED. These five sections were copied verbatim from `en.ts` so
  // this file still satisfies `Dictionary`; the page types they cover
  // (`taxonomy`, `compare`, `convert`) are deliberately absent from
  // TRANSLATED_PAGE_TYPES, so nothing publishes them in this language yet. The
  // translation pass replaces the strings and only then adds the types.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "찾을 수 없음",
    fieldMetaTitle: "{field} 인용 스타일 - 최고의 참고문헌 스타일 [2026]",
    fieldMetaDescription:
      "{field} 분야에서 가장 널리 쓰이는 인용 스타일을 알아보세요. {fieldLower} 논문, 학위논문, 투고 원고에 맞는 참고문헌 형식을 찾을 수 있습니다.",
    fieldOgTitle: "{field} 분야의 인용 스타일",
    fieldOgSubtitle: "주로 요구되는 스타일: {styles}.",
    fieldOgKind: "학문 분야별",
    fieldKeywordStyle: "{field} 인용 스타일",
    fieldKeywordReferencing: "{field} 참고문헌 표기법",
    fieldKeywordBest: "{fieldLower}에 가장 적합한 인용 스타일",
    fieldKeywordBibliography: "{fieldLower} 참고문헌 형식",
    fieldKeywordDiscipline: "학문 분야별 인용 스타일",
    fieldBackLink: "← 모든 인용 스타일",
    fieldHeading: "{field} 분야의 인용 스타일",
    fieldRecommendedHeading: "추천 인용 스타일",
    fieldRecommendedIntro:
      "다음은 {field} 분야의 연구, 학술지, 과제에서 흔히 쓰이는 인용 스타일입니다. 스타일을 선택하면 자세한 정보를 확인하고 인용을 만들 수 있습니다.",
    fieldStyleFallback: "{field} 및 관련 분야에서 사용되는 인용 스타일입니다.",
    fieldRelatedHeading: "관련 분야",
    fieldRelatedIntro: "관련 학문 분야에서 사용되는 인용 스타일을 살펴보세요:",
    fieldCtaHeading: "모든 인용 스타일 살펴보기",
    fieldCtaBody:
      "CitationEasy는 모든 학문 분야에 걸쳐 {count}개의 인용 스타일을 지원합니다. 전체 목록을 살펴보고 필요한 형식을 찾아보세요.",
    fieldCtaButton: "모든 스타일 보기 →",
    fieldFaqWhichQ: "{field} 분야에서는 어떤 인용 스타일을 사용하나요?",
    fieldFaqWhichA:
      "{field} 분야에서 사용하는 인용 스타일은 투고하는 학술지, 소속 기관, 또는 지도 교수의 요구 사항에 따라 달라집니다. 흔히 쓰이는 스타일로는 {styles}가 있습니다. 항상 과제 지침이나 투고하려는 학술지에서 요구하는 형식을 확인하세요.",
    fieldFaqSameQ: "{field} 분야의 학술지는 모두 같은 스타일을 사용하나요?",
    fieldFaqSameA:
      "아니요, {field} 분야의 모든 학술지가 같은 인용 스타일을 사용하는 것은 아닙니다. 특정 스타일이 해당 분야에서 더 흔히 쓰이기는 하지만, 개별 학술지마다 자체 서식 규정을 두는 경우가 있습니다. 원고를 준비하기 전에 반드시 투고하려는 학술지의 투고 규정을 확인하세요.",
    fieldFaqChooseQ: "{field} 논문에는 어떤 인용 스타일을 선택해야 하나요?",
    fieldFaqChooseA:
      "{field} 논문의 인용 스타일을 선택하려면, 먼저 지도 교수나 투고하려는 학술지가 지정한 스타일이 있는지 확인하세요. 지정된 스타일이 없다면 위에 소개된 {field} 분야의 추천 스타일 중 하나를 사용하면 됩니다. CitationEasy는 {count}개가 넘는 스타일을 지원하며, 어떤 스타일이든 무료로 인용을 생성할 수 있습니다.",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "국가를 찾을 수 없음",
    countryMetaTitle: "{country} 인용 스타일 - APA, MLA 등",
    countryMetaDescription:
      "{country}에서 사용되는 인용 스타일을 살펴보세요. {country} 형식을 지원하는 무료 인용 생성기입니다.",
    countryOgTitle: "{country}에서 사용되는 인용 스타일",
    countryOgKind: "국가별",
    countryHeading: "{country} 인용 스타일",
    countryIntroOne:
      "{country}에서 흔히 사용되거나 이 국가와 관련된 인용 스타일이 {count}개 있습니다. 하나를 선택하면 전용 생성기가 열립니다.",
    countryIntroMany:
      "{country}에서 흔히 사용되거나 이 국가와 관련된 인용 스타일이 {count}개 있습니다. 하나를 선택하면 전용 생성기가 열립니다.",
    countryBrowserTitle: "{country} 인용 스타일",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "유형을 찾을 수 없음",
    typeMetaTitle: "{type} 인용 스타일 - 무료 생성기",
    typeMetaDescription:
      "{typeLower} 분야를 위한 인용 스타일. APA, MLA, 밴쿠버 등. 무료 인용 생성기입니다.",
    typeOgTitle: "{type} 인용 스타일",
    typeOgKind: "주제별",
    typeHeading: "{type} 인용 스타일",
    typeIntroOne:
      "{typeLower} 분야를 위한 인용 스타일이 {count}개 있습니다. 하나를 선택하면 FAQ가 포함된 전용 생성기가 열립니다.",
    typeIntroMany:
      "{typeLower} 분야를 위한 인용 스타일이 {count}개 있습니다. 하나를 선택하면 FAQ가 포함된 전용 생성기가 열립니다.",
    typeBrowserTitle: "{type} 인용 스타일",

    // ---- Shared chrome ----
    breadcrumbStyles: "인용 스타일",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "인용 스타일",
    breadcrumbByCountry: "국가별",
    breadcrumbByDiscipline: "분야별",
    allStylesLink: "← 모든 인용 스타일",
    internationalLabel: "국제",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "심리학",
    education: "교육학",
    sociology: "사회학",
    anthropology: "인류학",
    politicalScience: "정치학",
    economics: "경제학",
    business: "경영학·비즈니스",
    literature: "문학·언어학",
    history: "역사학",
    philosophy: "철학",
    law: "법학",
    medicine: "의학·임상과학",
    nursing: "간호학·조산학",
    publicHealth: "공중보건학·역학",
    pharmacy: "약학",
    biology: "생물학·생명과학",
    chemistry: "화학",
    physics: "물리학",
    engineering: "공학",
    computerScience: "컴퓨터과학",
    mathematics: "수학·통계학",
    environmentalScience: "환경과학",
    earthScience: "지구과학·지질학",
    artHistory: "미술사·시각예술",
    music: "음악학",
    theology: "신학·종교학",
    socialWork: "사회복지학",
    linguistics: "언어학",
    architecture: "건축학·도시계획",
    filmMedia: "영화·미디어학",
    journalism: "저널리즘·커뮤니케이션학",
    criminology: "범죄학·형사사법",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "심리학, 행동과학, 인지과학 연구에서 흔히 사용되는 인용 스타일입니다.",
    education:
      "교육학 연구, 교수법, 교육과정 연구에 사용되는 인용 스타일입니다.",
    sociology: "사회학 연구와 사회 이론에 사용되는 인용 스타일입니다.",
    anthropology: "인류학 및 민족지학 연구에 사용되는 인용 스타일입니다.",
    politicalScience:
      "정치학, 행정학, 공공정책 연구에 사용되는 인용 스타일입니다.",
    economics: "경제학 및 계량경제학 연구에 사용되는 인용 스타일입니다.",
    business:
      "경영학, 마케팅, 재무 등 경영 분야 연구에 사용되는 인용 스타일입니다.",
    literature: "문학 연구, 언어학, 어학 연구에 사용되는 인용 스타일입니다.",
    history: "역사 연구, 사학사, 기록학 연구에 사용되는 인용 스타일입니다.",
    philosophy: "철학 저술과 윤리학 연구에 사용되는 인용 스타일입니다.",
    law: "법원 문서, 법학 평론, 법학 연구에 사용되는 법률 인용 스타일입니다.",
    medicine: "의학 연구, 임상 연구, 의료 분야에 사용되는 인용 스타일입니다.",
    nursing: "간호학 연구와 의료 실무에 사용되는 인용 스타일입니다.",
    publicHealth: "공중보건학 연구와 역학 연구에 사용되는 인용 스타일입니다.",
    pharmacy: "약학 및 약리학 연구에 사용되는 인용 스타일입니다.",
    biology: "생물학 연구, 생태학, 유전학에 사용되는 인용 스타일입니다.",
    chemistry: "화학, 생화학, 재료과학 연구에 사용되는 인용 스타일입니다.",
    physics:
      "물리학, 천체물리학, 응용물리학 연구에 사용되는 인용 스타일입니다.",
    engineering: "공학 및 응용기술 연구에 사용되는 인용 스타일입니다.",
    computerScience:
      "컴퓨터과학, 인공지능, 소프트웨어공학 연구에 사용되는 인용 스타일입니다.",
    mathematics: "수학, 응용수학, 통계학 연구에 사용되는 인용 스타일입니다.",
    environmentalScience:
      "환경 연구와 지속가능성 연구에 사용되는 인용 스타일입니다.",
    earthScience:
      "지질학, 지구물리학, 지구과학 연구에 사용되는 인용 스타일입니다.",
    artHistory: "미술사, 시각문화, 박물관학 연구에 사용되는 인용 스타일입니다.",
    music: "음악 연구, 음악 이론, 연주 연구에 사용되는 인용 스타일입니다.",
    theology: "신학 및 종교학 연구에 사용되는 인용 스타일입니다.",
    socialWork: "사회복지 연구와 실무에 사용되는 인용 스타일입니다.",
    linguistics: "언어학, 음성학, 언어과학 연구에 사용되는 인용 스타일입니다.",
    architecture:
      "건축학, 도시 설계, 도시계획 연구에 사용되는 인용 스타일입니다.",
    filmMedia:
      "영화, 텔레비전, 미디어, 커뮤니케이션 연구에 사용되는 인용 스타일입니다.",
    journalism:
      "저널리즘, 미디어학, 커뮤니케이션 연구에 사용되는 인용 스타일입니다.",
    criminology: "범죄학 및 형사사법 연구에 사용되는 인용 스타일입니다.",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "미국",
    unitedKingdom: "영국",
    australia: "호주",
    canada: "캐나다",
    newZealand: "뉴질랜드",
    ireland: "아일랜드",
    southAfrica: "남아프리카공화국",
    germany: "독일",
    france: "프랑스",
    spain: "스페인",
    italy: "이탈리아",
    netherlands: "네덜란드",
    belgium: "벨기에",
    switzerland: "스위스",
    austria: "오스트리아",
    portugal: "포르투갈",
    luxembourg: "룩셈부르크",
    sweden: "스웨덴",
    norway: "노르웨이",
    denmark: "덴마크",
    finland: "핀란드",
    iceland: "아이슬란드",
    poland: "폴란드",
    czechRepublic: "체코",
    hungary: "헝가리",
    romania: "루마니아",
    russia: "러시아",
    ukraine: "우크라이나",
    greece: "그리스",
    turkey: "튀르키예",
    croatia: "크로아티아",
    slovenia: "슬로베니아",
    slovakia: "슬로바키아",
    serbia: "세르비아",
    bulgaria: "불가리아",
    lithuania: "리투아니아",
    latvia: "라트비아",
    estonia: "에스토니아",
    japan: "일본",
    china: "중국",
    southKorea: "한국",
    india: "인도",
    singapore: "싱가포르",
    hongKong: "홍콩",
    taiwan: "대만",
    malaysia: "말레이시아",
    indonesia: "인도네시아",
    thailand: "태국",
    vietnam: "베트남",
    philippines: "필리핀",
    pakistan: "파키스탄",
    bangladesh: "방글라데시",
    sriLanka: "스리랑카",
    israel: "이스라엘",
    saudiArabia: "사우디아라비아",
    unitedArabEmirates: "아랍에미리트",
    brazil: "브라질",
    mexico: "멕시코",
    argentina: "아르헨티나",
    chile: "칠레",
    colombia: "콜롬비아",
    peru: "페루",
    venezuela: "베네수엘라",
    egypt: "이집트",
    nigeria: "나이지리아",
    kenya: "케냐",
    morocco: "모로코",
    international: "국제",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "의학",
    nursing: "간호학",
    publicHealth: "공중보건학",
    pharmacy: "약학",
    dentistry: "치의학",
    veterinary: "수의학",
    psychology: "심리학",
    sociology: "사회학",
    anthropology: "인류학",
    politicalScience: "정치학",
    economics: "경제학",
    education: "교육학",
    socialWork: "사회복지학",
    biology: "생물학",
    chemistry: "화학",
    physics: "물리학",
    environmentalScience: "환경과학",
    earthScience: "지구과학·지질학",
    agriculture: "농학",
    ecology: "생태학",
    engineering: "공학",
    computerScience: "컴퓨터과학",
    mathematics: "수학",
    statistics: "통계학",
    history: "역사학",
    literature: "문학",
    philosophy: "철학",
    linguistics: "언어학",
    artHistory: "미술사",
    music: "음악학",
    filmMedia: "영화·미디어학",
    archaeology: "고고학",
    law: "법학",
    business: "경영학",
    architecture: "건축학",
    religion: "종교학·신학",
    geography: "지리학",
    general: "종합·다학제",
    other: "기타",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "참고문헌 목록",
    listWorksCited: "인용문헌",
    listReferences: "참고문헌",
    listBibliography: "서지 목록",
    listTableOfAuthorities: "판례·법령 목록",
    listReferencesCited: "인용 참고문헌",
    listLowerReferenceList: "참고문헌 목록",
    listLowerWorksCited: "인용문헌",
    listLowerReferences: "참고문헌",
    listLowerBibliography: "서지 목록",
    listLowerTableOfAuthorities: "판례·법령 목록",
    listLowerReferencesCited: "인용 참고문헌",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(저자, 연도)",
    inTextAuthorPage: "(저자 쪽)",
    inTextAuthorYear: "(저자 연도)",
    inTextSuperscriptOrBracketed: "위첨자 또는 괄호 숫자 (1)",
    inTextBracketedNumbers: "대괄호 숫자 [1]",
    inTextSuperscriptNumbers: "위첨자 숫자¹",
    inTextSuperscriptOrAuthorYear: "위첨자 숫자 또는 (저자 연도)",
    inTextKeyBased: "키 기반 참조",
    inTextSuperscriptOrAuthorCommaYear: "위첨자 숫자 또는 (저자, 연도)",
    inTextFootnotesCaseLegislation: "판례·법령 인용이 포함된 각주",
    inTextFootnotesSignals: "신호어 약어가 포함된 각주",
    inTextFootnotesPinpoint: "정확한 위치를 표시하는 각주",
    inTextParenNumbers: "괄호 숫자 (1)",
    inTextItalicNumbers: "이탤릭체 숫자 (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "4판",
    edition5th: "5판",
    edition7th: "7판",
    edition8th: "8판",
    edition9th: "9판",
    edition11th: "11판",
    edition18th: "18판",
    edition22nd: "22판",
    editionCiteThemRight11th: "Cite Them Right 11판",
    editionIcmjeStandard: "ICMJE 표준",
    editionStandard: "표준",
    editionCurrent: "최신판",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "음향학",
    fieldAnthropology: "인류학",
    fieldAppliedPhysics: "응용물리학",
    fieldArchaeology: "고고학",
    fieldArts: "예술",
    fieldAstrophysics: "천체물리학",
    fieldAustralianLaw: "호주법",
    fieldBiochemistry: "생화학",
    fieldBiology: "생물학",
    fieldBiomedicalSciences: "생물의학",
    fieldBiotechnology: "생명공학",
    fieldBusiness: "비즈니스",
    fieldCellBiology: "세포생물학",
    fieldChemicalEngineering: "화학공학",
    fieldChemistry: "화학",
    fieldClinicalResearch: "임상연구",
    fieldComputerScience: "컴퓨터과학",
    fieldCondensedMatter: "응집물질물리학",
    fieldCourtDocuments: "법원 문서",
    fieldCriminology: "범죄학",
    fieldCulturalStudies: "문화연구",
    fieldDemography: "인구학",
    fieldEcology: "생태학",
    fieldEducation: "교육학",
    fieldElectronics: "전자공학",
    fieldEngineering: "공학",
    fieldEnvironmentalScience: "환경과학",
    fieldEpidemiology: "역학",
    fieldEthnography: "민족지학",
    fieldGenetics: "유전학",
    fieldGeology: "지질학",
    fieldGlobalHealth: "국제보건학",
    fieldHealthSciences: "보건과학",
    fieldHistory: "역사학",
    fieldHumanities: "인문학",
    fieldInformationSystems: "정보시스템학",
    fieldInformationTechnology: "정보기술",
    fieldInternationalRelations: "국제관계학",
    fieldJurisprudence: "법리학",
    fieldLanguages: "언어",
    fieldLaw: "법학",
    fieldLawReview: "법학평론",
    fieldLegalStudies: "법학연구",
    fieldLifeSciences: "생명과학",
    fieldLiterature: "문학",
    fieldMaterialsScience: "재료과학",
    fieldMathematics: "수학",
    fieldMedicine: "의학",
    fieldMolecularBiology: "분자생물학",
    fieldMultidisciplinary: "다학제",
    fieldMultidisciplinaryScience: "다학제 과학",
    fieldNaturalSciences: "자연과학",
    fieldNursing: "간호학",
    fieldPharmacy: "약학",
    fieldPhysics: "물리학",
    fieldPoliticalScience: "정치학",
    fieldPsychology: "심리학",
    fieldPublicHealth: "공중보건학",
    fieldPublicPolicy: "공공정책",
    fieldPublishing: "출판학",
    fieldScience: "과학",
    fieldSciences: "과학 전반",
    fieldSocialSciences: "사회과학",
    fieldSocialWork: "사회복지학",
    fieldSociology: "사회학",
    fieldSoftwareEngineering: "소프트웨어공학",
    fieldTheology: "신학",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "사회과학 분야에서 가장 널리 사용되는 인용 스타일입니다",
    mla: "인문학의 표준 인용 스타일입니다",
    chicago:
      "저자와 편집자, 출판사들에게 가장 신뢰받는 미국의 스타일 가이드입니다",
    harvard: "영국과 호주 대학에서 가장 인기 있는 참고문헌 스타일입니다",
    vancouver: "의학 및 생의학 학술지의 표준 인용 스타일입니다",
    ieee: "공학과 컴퓨터과학 분야에서 가장 널리 쓰이는 인용 스타일입니다",
    ama: "미국 의학 학술지의 인용 기준입니다",
    turabian: "Chicago 스타일을 학생 친화적으로 간소화한 버전입니다",
    cse: "자연과학 및 물리과학 분야에서 선호되는 인용 스타일입니다",
    bibtex: "LaTeX 사용자와 학술 조판을 위한 참고문헌 형식입니다",
    nature: "세계적인 다학제 학술지에서 사용되는 인용 스타일입니다",
    acs: "화학 및 화학 관련 과학 분야의 인용 기준입니다",
    oscola: "영국 법과대학과 법학 학술지의 표준 법률 인용 스타일입니다",
    bluebook:
      "미국 법원과 법학 평론에서 사용되는 대표적인 법률 인용 체계입니다",
    aglc: "호주 법과대학과 법원의 표준 법률 인용 스타일입니다",
    asa: "사회학 및 사회 연구의 표준 인용 스타일입니다",
    apsa: "정치학 연구와 학술지를 위한 인용 스타일입니다",
    aaa: "인류학 연구의 표준 인용 스타일입니다",
    nlm: "PubMed와 미국 국립 의학도서관에서 사용하는 인용 기준입니다",
    acm: "ACM 학회와 컴퓨팅 연구를 위한 인용 스타일입니다",
    aps: "Physical Review와 APS 학술지를 위한 인용 스타일입니다",
    aip: "AIP와 물리학 학술지를 위한 인용 스타일입니다",
    cell: "Cell Press와 주요 생물학 학술지를 위한 인용 스타일입니다",
    science: "Science지와 AAAS 학술지를 위한 인용 스타일입니다",
    plos: "PLOS 오픈액세스 학술지를 위한 인용 스타일입니다",
    bmj: "BMJ와 영국의 주요 의학 학술지를 위한 인용 스타일입니다",
    lancet: "The Lancet 계열 의학 학술지를 위한 인용 스타일입니다",
    jama: "JAMA와 JAMA Network 학술지를 위한 인용 스타일입니다",
    elsevierHarvard:
      "Elsevier 학술지 전반에서 사용되는 Harvard 스타일의 변형입니다",
    springer: "Springer Nature의 학술지와 도서를 위한 인용 스타일입니다",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "찾을 수 없음",
    metaTitle: "{a} vs {b} - 주요 차이점 정리 [2026]",
    metaDescription:
      "{a} 스타일과 {b} 스타일을 나란히 비교합니다. 서식, 본문 내 인용, 참고문헌 목록의 주요 차이를 알아보고 논문에 맞는 스타일을 선택하세요.",
    ogTitle: "{a} vs {b}",
    ogSubtitle:
      "본문 내 인용 형식, 참고문헌 항목, 대소문자 표기, 각 스타일이 요구되는 분야를 비교합니다.",
    ogKind: "스타일 비교",
    keywordVs: "{a} vs {b}",
    keywordVersus: "{a} 대 {b}",
    keywordDifference: "{a} 스타일과 {b} 스타일의 차이",
    keywordOr: "{a} 또는 {b}",
    keywordComparison: "인용 스타일 비교",
    breadcrumbCompare: "스타일 비교",
    breadcrumbCurrent: "{a} vs {b}",
    backLink: "← 비교 도구로 돌아가기",
    heading: "{a} vs {b}: 주요 차이점",
    intro:
      "{a} 스타일과 {b} 스타일은 학계에서 가장 널리 쓰이는 인용 스타일 중 두 가지이지만, 중요한 차이가 있습니다. {introA} {introB} 이 차이를 이해하면 논문에 맞는 형식을 선택하는 데 도움이 됩니다.",
    styleIntro: "{style}({fullName}) 스타일은 {tagline}.",
    styleIntroFallback:
      "{style} 스타일은 많은 학문 분야에서 사용되는 인기 있는 인용 스타일입니다.",
    tableHeading: "나란히 비교하기",
    tableFeature: "항목",
    tableCitationSystem: "인용 방식",
    tableInText: "본문 내 인용 형식",
    tableReferenceList: "참고문헌 목록 이름",
    tableEdition: "판",
    tableCommonFields: "주요 분야",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "저자–연도",
    systemNumbered: "번호식",
    systemFootnotes: "각주식",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "괄호 안 저자–연도 방식",
    describeNumbered: "번호식",
    describeFootnotes: "각주식",
    whenToUseHeading: "{style} 사용 시점",
    whenToUseBody:
      "{style}({fullName}) 스타일은 {system}을 사용하며, 본문 내 인용은 {inText} 형식을, 논문 끝에는 {list} 형식을 사용합니다. 주로 {fields}{more}에서 사용됩니다.",
    whenToUseMoreFields: ", 그리고 관련 분야",
    whenToUseFallback:
      "{style} 스타일은 널리 알려진 인용 스타일입니다. {style} 스타일이 요구되는 형식인지 과제 지침이나 투고하려는 학술지에서 확인하세요.",
    ctaHeading: "실제 차이를 확인해 보세요",
    ctaBodyBefore: "저희",
    ctaBodyLink: "인터랙티브 비교 도구",
    ctaBodyAfter:
      "를 사용해 직접 가진 자료로 {a} 스타일과 {b} 스타일의 인용을 나란히 비교해 보세요.",
    ctaCiteIn: "{style} 스타일로 인용하기 →",
    faqDifferenceQ: "{a} 스타일과 {b} 스타일의 차이는 무엇인가요?",
    faqDifferenceA:
      "{a} 스타일과 {b} 스타일은 본문 내 인용 형식, 참고문헌 목록 구조, 사용되는 학문 분야에서 차이가 있습니다. {detail}",
    faqDifferenceDetail:
      "{a} 스타일은 {inTextA} 형식의 본문 내 인용과 {listA}을 사용하고, {b} 스타일은 {inTextB} 형식과 {listB}을 사용합니다.",
    faqDifferenceDetailFallback:
      "각 스타일은 인용 서식, 참고문헌 구성, 자료 유형 처리 방식에 대해 저마다 다른 규칙을 가지고 있습니다.",
    faqBetterQ: "{a} 스타일과 {b} 스타일 중 어느 쪽이 더 나은가요?",
    faqBetterA:
      "{a} 스타일과 {b} 스타일 중 어느 쪽도 본질적으로 더 낫다고 할 수 없습니다. 올바른 선택은 학문 분야, 지도 교수의 요구 사항, 또는 투고하려는 학술지에 따라 달라집니다. 어떤 스타일을 사용해야 할지는 과제 지침이나 투고하려는 간행물에서 확인하세요.",
    faqSwitchQ: "{a} 스타일과 {b} 스타일 사이를 전환할 수 있나요?",
    faqSwitchA:
      "네, CitationEasy의 무료 인용 생성기를 사용하면 {a} 스타일과 {b} 스타일 사이를 전환할 수 있습니다. 원하는 스타일을 선택하면 인용이 자동으로 다시 서식이 적용됩니다. 다만, 지도 교수의 별도 지시가 없는 한 하나의 논문에는 하나의 스타일만 사용해야 합니다.",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "변환기를 찾을 수 없음",
    metaTitle: "{title} - 무료·즉시 변환",
    ogTitle: "{title}",
    ogKind: "변환기",
    breadcrumbConverters: "변환기",
    breadcrumbLabel: "이동 경로",
    whenHeading: "이럴 때 필요합니다",
    relatedHeading: "관련 변환기",
    allConverters: "모든 변환기",
    formatConverterTool: "인용 형식 변환기",
    faqHowQ: "{input} 형식을 {output} 형식으로 변환하려면 어떻게 하나요?",
    faqHowA:
      "{intro} 모든 기능이 무료이며, 계정 등록이나 변환 횟수 제한이 없습니다.",
    faqPrivacyQ: "제 데이터가 어딘가에 업로드되나요?",
    faqPrivacyIdentifier:
      "각 {input} 항목은 관련 공개 메타데이터 서비스(DOI는 Crossref, PMID는 PubMed, ISBN은 도서관 서지 정보)에서 조회되며, 전송되는 것은 식별자 자체뿐입니다 — 문서가 전송되는 일은 없습니다. 서식이 적용된 결과는 복사하거나 다운로드할 수 있으며, 아무것도 저장되지 않습니다.",
    faqPrivacyLocal:
      "아니요 — 붙여넣거나 업로드한 {input} 항목은 브라우저에서 전부 해석됩니다. {detail}",
    faqPrivacyDetailStyle:
      "인용을 생성하기 위해 서식 도구로 전송되는 것은 분석된 참고문헌 항목(저자, 제목, 연도)뿐입니다. 파일 자체가 사용자의 기기를 벗어나는 일은 없습니다.",
    faqPrivacyDetailOffline:
      "변환은 페이지 안에서 완전히 오프라인으로 실행되며, 어떤 서버로도 전송되지 않습니다.",
    faqUsefulQ:
      "{input} 형식을 {output} 형식으로 변환하는 기능은 언제 유용한가요?",
    faqOtherQ: "다른 스타일이나 형식으로도 변환할 수 있나요?",
    faqOtherA:
      "네. CitationEasy의 생성기는 모든 자료를 {count}개의 인용 스타일로 서식화할 수 있으며, 참고문헌 목록은 Word, RTF, BibTeX, RIS, CSL-JSON으로 내보낼 수 있습니다. 변환기 허브에는 모든 직접 변환 쌍이 정리되어 있습니다. 이미 서식이 적용된 텍스트를 스타일 간에 다시 쓰고 싶다면, 대신 인용 형식 변환기를 이용하세요.",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "DOI → APA 인용 변환기",
    doiToApaMetaDescription:
      "DOI를 한 줄에 하나씩 붙여넣으면 출판사의 공식 Crossref 메타데이터를 바탕으로 APA 7판 참고문헌을 즉시 생성합니다. 무료, 계정 불필요.",
    doiToApaIntro:
      "DOI는 이미 출판사의 공식 메타데이터를 가리키고 있으므로 APA 참고문헌을 직접 입력할 이유가 없습니다. DOI를 한 줄에 하나씩 붙여넣으면 저자명 도치, 문장식 대문자 표기의 제목, 이탤릭체 학술지명, 그리고 APA가 요구하는 https://doi.org/ 링크까지 갖춘 완전한 APA 7판 참고문헌이 완성됩니다.",
    doiToApaUseCase:
      "흔한 상황: 교수님은 APA 참고문헌 목록을 원하는데, 손에 있는 건 자료를 읽으며 저장해 둔 DOI 더미뿐일 때. 그 더미를 붙여넣고, 완성된 목록을 복사하기만 하면 됩니다.",
    doiToMlaTitle: "DOI → MLA 인용 변환기",
    doiToMlaMetaDescription:
      "Crossref 메타데이터를 이용해 DOI를 MLA 9판 인용문헌 목록 항목으로 자동 변환합니다. DOI를 한 줄에 하나씩 붙여넣기만 하면 됩니다 — 무료, 설치 불필요.",
    doiToMlaIntro:
      "MLA 9판은 학술지 논문을 '컨테이너 사슬'로 다룹니다 — 따옴표로 묶은 논문 제목, 이탤릭체 학술지명, 권, 호, 연도, 페이지까지, 수작업으로 맞추기엔 까다롭습니다. DOI 조회는 출판사 기록에서 모든 항목을 채워 넣으므로 인용문헌 목록 항목이 처음부터 정확하게 완성됩니다.",
    doiToMlaUseCase:
      "인문학 강의에서는 MLA를 요구하는데 자료는 과학 계열 데이터베이스에서 DOI만 얻을 수 있을 때 유용합니다.",
    doiToBibtexTitle: "DOI → BibTeX 변환기",
    doiToBibtexMetaDescription:
      "DOI를 LaTeX과 Overleaf용 BibTeX 항목으로 변환합니다. DOI를 한 줄에 하나씩 붙여넣고 완성된 .bib 파일을 내려받으세요 — 무료, 횟수 제한 없음.",
    doiToBibtexIntro:
      "모든 LaTeX 논문은 결국 .bib 파일이 필요합니다. DOI를 한 줄씩 붙여넣으면 인용 키가 자동 생성된 깔끔한 @article 항목을 얻을 수 있으며, Overleaf와 natbib, biblatex에 그대로 사용할 수 있습니다 — 출판사 페이지에서 항목을 일일이 옮겨 적을 필요가 없습니다.",
    doiToBibtexUseCase:
      "흔한 흐름: 심사자가 인용할 논문 세 편을 보내왔고, DOI는 있는데 마감은 오늘 밤일 때. 붙여넣고, 내려받고, \\cite만 하면 됩니다.",
    doiToRisTitle: "DOI → RIS 변환기",
    doiToRisMetaDescription:
      "DOI를 Zotero, Mendeley, EndNote가 곧바로 불러올 수 있는 RIS 파일로 변환합니다. DOI를 한 줄에 하나씩 붙여넣기만 하면 됩니다 — 무료, 가입 불필요.",
    doiToRisIntro:
      "RIS는 모든 참고문헌 관리 프로그램이 불러올 수 있는 교환 형식입니다. DOI를 붙여넣으면 TY/AU/TI/T2 항목이 Crossref에서 바로 반영된 .ris 파일을 내려받을 수 있습니다 — 이후 Zotero, Mendeley, EndNote에서 파일 → 가져오기만 하면 항목이 완전히 구조화된 채로 들어옵니다.",
    doiToRisUseCase:
      "손수 모은 DOI 목록을 제대로 된 참고문헌 관리 프로그램으로 옮길 때 딱 맞습니다. 저자명을 단 하나도 다시 입력할 필요가 없습니다.",
    isbnToApaTitle: "ISBN → APA 인용 변환기",
    isbnToApaMetaDescription:
      "ISBN을 APA 7판 도서 참고문헌으로 자동 변환합니다. ISBN을 한 줄에 하나씩 붙여넣고 정리된 목록을 복사하세요 — 무료, 계정 불필요.",
    isbnToApaIntro:
      "책의 판권면에 있는 ISBN만 있으면 APA 참고문헌을 완성할 수 있습니다. 각 ISBN은 도서관 메타데이터와 대조되어 저자, 발행연도, 이탤릭체 제목, 출판사까지 APA 7판 형식으로 정리되며, 기록에 판 정보가 있으면 그것도 함께 표시됩니다.",
    isbnToApaUseCase:
      "쌓여 있는 실물 도서관 책을 인용하는 가장 빠른 방법입니다. 각 책의 판권면을 펼쳐 ISBN을 입력하고, 여기에 목록으로 붙여넣기만 하면 됩니다.",
    isbnToMlaTitle: "ISBN → MLA 인용 변환기",
    isbnToMlaMetaDescription:
      "ISBN을 한 번에 붙여넣어 MLA 9판 인용문헌 목록 항목으로 변환합니다. 무료 ISBN 조회로 정리된 결과를 얻으세요 — 가입 불필요.",
    isbnToMlaIntro:
      "MLA 9판의 도서 항목은 짧습니다 — 저자, 이탤릭체 제목, 출판사, 연도 — 하지만 저자명 도치와 구두점을 정확히 맞추는 일은 여전히 까다롭습니다. ISBN 조회는 책의 실제 목록 기록을 가져와 MLA 핸드북의 핵심 요소 서식에 맞춰 정리해 줍니다.",
    isbnToMlaUseCase:
      "문학 과제에 이상적입니다. 책상 위의 소설과 비평서를 모두 인용하는 데 필요한 건 표지 뒷면의 숫자를 입력하는 것뿐입니다.",
    isbnToBibtexTitle: "ISBN → BibTeX 변환기",
    isbnToBibtexMetaDescription:
      "ISBN을 LaTeX용 BibTeX @book 항목으로 변환합니다. ISBN을 한 줄에 하나씩 붙여넣고 .bib 파일을 내려받으세요 — 무료, 즉시 처리.",
    isbnToBibtexIntro:
      "도서는 BibTeX에서 다루기 까다로운 부분입니다 — 조회할 DOI가 없고, 출판사 페이지에서 .bib 내보내기를 제공하는 경우도 드뭅니다. 이 변환기는 각 ISBN을 도서관 메타데이터와 대조해 저자, 제목, 출판사, 연도 항목이 채워진 @book 항목을 만들어 줍니다.",
    isbnToBibtexUseCase:
      "학위논문 작성자를 위한 기능: 방법론 장에서는 학술지 DOI를 인용하지만 이론 장에서는 책 열두 권을 인용해야 할 때, 그 열두 권을 여기서 처리할 수 있습니다.",
    pmidToApaTitle: "PMID → APA 인용 변환기",
    pmidToApaMetaDescription:
      "PubMed ID를 APA 7판 참고문헌으로 자동 변환합니다. PMID를 한 줄에 하나씩 붙여넣고 정리된 참고문헌 목록을 받으세요 — 무료.",
    pmidToApaIntro:
      "PubMed의 모든 기록에는 PMID가 있으며, 심리학과 간호학 과정 대부분은 APA를 요구합니다. PMID를 한 줄씩 붙여넣으면 PubMed 자체 메타데이터를 통해 완전한 APA 7판 학술지 논문 참고문헌으로 변환되며, 기록에 DOI가 있으면 링크도 함께 포함됩니다.",
    pmidToApaUseCase:
      "근거 기반 실무 과제를 위해 만들어졌습니다. 검색 전략의 결과가 PMID 목록으로 끝나는데, 논문에는 APA 형식으로 정리해야 할 때 유용합니다.",
    pmidToRisTitle: "PMID → RIS 변환기",
    pmidToRisMetaDescription:
      "PubMed ID를 Zotero, Mendeley, EndNote용 RIS 파일로 변환합니다. PMID를 한 줄에 하나씩 붙여넣고 .ris를 내려받으세요 — 무료.",
    pmidToRisIntro:
      "체계적 문헌고찰 작업은 RIS 파일을 중심으로 돌아갑니다. PubMed 검색 결과의 PMID를 붙여넣으면 스크리닝 도구나 참고문헌 관리 프로그램에 바로 쓸 수 있는 .ris를 내려받을 수 있습니다 — 각 기록은 스크래핑한 텍스트가 아니라 PubMed의 정식 메타데이터로 구조화됩니다.",
    pmidToRisUseCase:
      "문헌고찰 도중, 동료가 '이 연구 다섯 편도 추가해 주세요'라며 PMID만 이메일로 보내오고 내 문헌은 EndNote에 있을 때 유용합니다.",
    arxivToBibtexTitle: "arXiv → BibTeX 변환기",
    arxivToBibtexMetaDescription:
      "arXiv ID를 LaTeX 논문용 BibTeX 항목으로 변환합니다. 2301.12345 같은 ID를 한 줄에 하나씩 붙여넣고 .bib를 내려받으세요 — 무료.",
    arxivToBibtexIntro:
      "빠르게 변화하는 분야에서는 프리프린트가 끊임없이 인용되며, arXiv ID(예: 2301.12345)는 그 유통 방식입니다. ID를 붙여넣으면 프리프린트의 저자, 제목, 연도, arXiv 링크가 담긴 BibTeX 항목을 얻을 수 있으며, 논문의 .bib 파일에 바로 사용할 수 있습니다.",
    arxivToBibtexUseCase:
      "관련 연구 절의 80%가 arXiv인 머신러닝·물리학 저자를 위한 기능입니다. 읽으면서 ID를 모아 두었다가 집필 시점에 한 번에 붙여넣어 변환하세요.",
    bibtexToApaTitle: "BibTeX → APA 변환기",
    bibtexToApaMetaDescription:
      ".bib 파일을 붙여넣거나 업로드하면 APA 7판 참고문헌 목록을 얻을 수 있습니다. 여러 항목이 담긴 파일도 처리합니다 — 무료, 분석은 브라우저에서 실행됩니다.",
    bibtexToApaIntro:
      "때로는 논문이 LaTeX을 벗어나기도 합니다 — 학술지가 Word 원고를 요구하거나, 위원회가 참고문헌 목록을 일반 텍스트로 요구할 때입니다. BibTeX를 붙여넣거나 .bib를 업로드하면 모든 항목이 브라우저에서 분석되어 어떤 문서에도 바로 넣을 수 있는 APA 7판 참고문헌 목록으로 정리됩니다.",
    bibtexToApaUseCase:
      "지원금 신청서에 자주 쓰이는 기능입니다. 논문 목록은 .bib 파일로 관리하는데, 지원 기관 양식은 텍스트 상자에 APA 형식 참고문헌을 요구할 때 유용합니다.",
    bibtexToMlaTitle: "BibTeX → MLA 변환기",
    bibtexToMlaMetaDescription:
      "BibTeX를 MLA 9판 인용문헌 목록 항목으로 변환합니다. .bib 파일을 붙여넣거나 업로드하고 정리된 목록을 복사하세요 — 무료, 계정 불필요.",
    bibtexToMlaIntro:
      "BibTeX는 원본 항목을 저장할 뿐이고, MLA는 이를 어떻게 배열할지 정확히 규정합니다. 이 변환기는 .bib 항목을 브라우저에서 로컬로 분석해 각각을 MLA 9판 서식에 맞춰 표현합니다 — 저자명 도치, 따옴표로 묶은 논문 제목, 이탤릭체 컨테이너명, 요소 사이의 정확한 구두점까지.",
    bibtexToMlaUseCase:
      "여러 분야를 넘나드는 연구자를 위한 기능입니다. 참고문헌은 과거 LaTeX 작업에서 BibTeX로 남아 있는데, 투고하려는 인문학 학술지는 MLA를 요구할 때 유용합니다.",
    bibtexToRisTitle: "BibTeX → RIS 변환기",
    bibtexToRisMetaDescription:
      ".bib 파일을 Zotero, Mendeley, EndNote용 RIS로 변환합니다. BibTeX를 붙여넣거나 업로드하고 .ris를 내려받으세요 — 무료, 오프라인으로 동작합니다.",
    bibtexToRisIntro:
      "LaTeX 도구에서 참고문헌 관리 프로그램으로 옮기려면 BibTeX의 @article/@book 항목을 RIS의 TY/AU/TI 태그로 변환해야 합니다. 변환은 필드 매핑까지 포함해 전부 브라우저에서 이루어지며, 어떤 관리 프로그램에서도 불러올 수 있는 .ris 파일을 만들어 줍니다.",
    bibtexToRisUseCase:
      "흔히 이런 계기로 필요해집니다: 새 공동 저자가 Zotero를 쓰고, 공유 참고문헌은 저장소 안의 .bib 파일이라 누군가 그 간극을 이어야 할 때입니다.",
    bibtexToCslJsonTitle: "BibTeX → CSL-JSON 변환기",
    bibtexToCslJsonMetaDescription:
      "BibTeX를 Pandoc과 Quarto용 CSL-JSON으로 변환합니다. .bib를 붙여넣거나 업로드하고 references.json을 내려받으세요 — 무료, 브라우저에서 처리.",
    bibtexToCslJsonIntro:
      "Pandoc과 Quarto는 CSL-JSON을 기본 형식으로 인용하므로, 기존 .bib를 변환해 두면 빌드 과정에서 움직이는 부품을 하나 줄일 수 있습니다. 항목은 브라우저에서 분석되어 --bibliography=references.json이 정확히 요구하는 형태의 깔끔한 CSL-JSON 배열로 출력됩니다.",
    bibtexToCslJsonUseCase:
      "오래된 LaTeX 프로젝트를 Quarto로 옮기는 마크다운 중심 연구자를 위한 기능입니다. JSON을 직접 편집하지 않고도 참고문헌을 그대로 옮길 수 있습니다.",
    bibtexToWordTitle: "BibTeX → Word 변환기",
    bibtexToWordMetaDescription:
      ".bib 파일을 APA 형식, 내어쓰기가 적용된 참고문헌 목록이 담긴 Word 문서로 변환합니다. 무료 — 분석은 브라우저에서 이루어집니다.",
    bibtexToWordIntro:
      ".bib 파일을 다른 데이터 형식이 아니라 문서 자체로 만들어야 할 때, 이 변환기는 BibTeX를 로컬에서 분석하고 모든 항목을 APA 7판으로 정리한 뒤, 이미 알파벳순으로 정렬되고 내어쓰기까지 적용된 참고문헌 목록이 담긴 Word 파일을 내려받게 해 줍니다.",
    bibtexToWordUseCase:
      "작업 흐름의 마지막 단계에서 자주 쓰입니다. 학술지가 논문을 채택했지만 최종 참고문헌 목록을 편집 가능한 Word 파일로 요구하고, 원본 자료는 BibTeX일 때 유용합니다.",
    risToApaTitle: "RIS → APA 변환기",
    risToApaMetaDescription:
      "RIS 내보내기 파일을 붙여넣거나 업로드하면 APA 7판 참고문헌 목록을 얻을 수 있습니다. Zotero, Mendeley, EndNote, 데이터베이스 내보내기와 모두 호환됩니다 — 무료.",
    risToApaIntro:
      "어떤 데이터베이스든 '내보내기' 버튼을 누르면 RIS가 나오지만, 과제는 APA를 요구합니다. 내보내기 파일을 붙여넣거나 .ris를 업로드하면 TY/AU/TI 기록이 브라우저에서 분석되어 APA 7판 참고문헌으로 정리됩니다 — 참고문헌 관리 프로그램을 설치할 필요가 없습니다.",
    risToApaUseCase:
      "도서관 데이터베이스를 위한 지름길입니다. 검색 결과를 RIS로 내보내고 여기서 변환하면, 한 번뿐인 논문을 위해 Zotero를 설정하는 수고를 덜 수 있습니다.",
    risToMlaTitle: "RIS → MLA 변환기",
    risToMlaMetaDescription:
      "데이터베이스나 참고문헌 관리 프로그램에서 내보낸 RIS를 MLA 9판 인용문헌 목록 항목으로 변환합니다. 붙여넣거나 업로드하세요 — 무료, 가입 불필요.",
    risToMlaIntro:
      "JSTOR, ProQuest, EBSCO는 모두 RIS를 내보내지만, 영문학과는 하나같이 MLA를 요구합니다. 이 페이지가 그 간극을 메워 줍니다 — 기록은 로컬에서 분석되어 MLA 9판 핵심 요소 서식에 맞춰 표현되므로, 인용문헌 목록 페이지에 바로 붙여넣을 수 있습니다.",
    risToMlaUseCase:
      "과제 마감 전날 밤을 위한 기능입니다. JSTOR에서 citations.ris로 내보낸 자료 열 편을, 손수 정리하고 싶지 않을 때 유용합니다.",
    risToBibtexTitle: "RIS → BibTeX 변환기",
    risToBibtexMetaDescription:
      "RIS를 LaTeX과 Overleaf용 BibTeX로 변환합니다. .ris 내보내기 파일을 붙여넣거나 업로드하고 깔끔한 .bib 파일을 내려받으세요 — 무료, 브라우저에서 처리.",
    risToBibtexIntro:
      "LaTeX 방향으로 옮겨 갈 때: 참고문헌 관리 프로그램과 데이터베이스는 RIS로 말하지만, 논문 빌드에는 .bib가 필요합니다. 기록은 전부 브라우저에서 변환되며 — TY 태그로 유형이 매핑되고 인용 키도 생성되어 — Overleaf가 그대로 받아들이는 파일이 됩니다.",
    risToBibtexUseCase:
      "공동 연구에서 흔한 상황입니다. Zotero 사용자는 RIS를 내보내고 LaTeX 사용자는 이 페이지를 거치게 하면, 각자 자신의 도구를 그대로 쓸 수 있습니다.",
    risToCslJsonTitle: "RIS → CSL-JSON 변환기",
    risToCslJsonMetaDescription:
      "RIS 내보내기를 Pandoc과 Quarto 파이프라인용 CSL-JSON으로 변환합니다. .ris를 붙여넣거나 업로드하고 references.json을 내려받으세요 — 무료.",
    risToCslJsonIntro:
      "Pandoc과 Quarto 사용자에게 CSL-JSON은 기본 참고문헌 형식입니다. 데이터베이스나 관리 프로그램이 내보낸 RIS를 이 페이지에 넣으면 구조화된 JSON 배열을 돌려받습니다 — 모든 기록은 로컬에서 분석되며 어디에도 업로드되지 않습니다.",
    risToCslJsonUseCase:
      "docs-as-code 작업 흐름에 딱 맞습니다. 심사자는 RIS 첨부 파일을 보내오고, 저장소의 인용 파일은 references.json이며, 이 페이지가 그 둘을 이어 줍니다.",
    cslJsonToBibtexTitle: "CSL-JSON → BibTeX 변환기",
    cslJsonToBibtexMetaDescription:
      "CSL-JSON(Pandoc/Quarto/Zotero 내보내기)을 BibTeX로 변환합니다. .json을 붙여넣거나 업로드하고 .bib를 내려받으세요 — 무료, 브라우저에서 처리.",
    cslJsonToBibtexIntro:
      "때로는 흐름이 반대가 되기도 합니다 — Pandoc이나 Zotero 파이프라인에서 만들어진 참고문헌을 LaTeX 빌드에 넣어야 할 때입니다. 이 변환기는 브라우저에서 CSL-JSON 배열을 읽어, CSL 모델에서 유형과 필드를 다시 매핑한 BibTeX 항목을 만들어 줍니다.",
    cslJsonToBibtexUseCase:
      "공동 저자가 Overleaf를 고집하는 Quarto 저자를 위한 기능입니다. references.json을 원본으로 유지하면서 필요할 때마다 .bib를 생성할 수 있습니다.",
    cslJsonToRisTitle: "CSL-JSON → RIS 변환기",
    cslJsonToRisMetaDescription:
      "CSL-JSON을 RIS로 변환해 Zotero, Mendeley, EndNote에서 불러올 수 있게 합니다. .json을 붙여넣거나 업로드하고 .ris를 내려받으세요 — 무료.",
    cslJsonToRisIntro:
      "CSL-JSON은 Pandoc 파이프라인 안에서는 훌륭하지만, 대부분의 참고문헌 관리 프로그램의 가져오기 창에는 통하지 않습니다. RIS로 변환하면 같은 기록을 어떤 프로그램에서도 불러올 수 있게 됩니다 — 각 항목은 브라우저에서 TY/AU/TI 태그로 매핑되며, 서버로는 아무것도 전송되지 않습니다.",
    cslJsonToRisUseCase:
      "인수인계의 어려움을 해결합니다. 참고문헌은 git 저장소 안의 references.json인데, 지도 교수는 금요일까지 'EndNote 형식으로' 달라고 할 때 유용합니다.",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "모든 인용 스타일",
    styleSingular: "개 스타일",
    stylePlural: "개 스타일",
    found: "검색됨",
    filterPlaceholder: "스타일 검색...",
    noMatches: "검색 결과와 일치하는 스타일이 없습니다.",
    loadingMore: "스타일을 더 불러오는 중...",
    loadMore: "더 불러오기 (남은 {count}개)",
    showingAll: "전체 {count}개 스타일 표시 중",
    internationalLabel: "국제",
  },

  footer: {
    tagline:
      "{count}개 스타일을 지원하는 무료 인용 생성기. 계정과 유료 구독이 필요 없고 제한도 없습니다.",
    freeTools: "무료 도구",
    resources: "자료",
    legal: "법적 고지",
    language: "언어",
    languageLabel: "언어 선택",
    rights:
      "인용은 Citation Style Language의 공식 정의에 따라 서식이 적용됩니다.",
    popularStyles: "많이 쓰는 스타일",
    about: "소개",
    privacy: "개인정보",
    terms: "이용약관",
    contact: "문의",
    copyright: "© {year} CitationEasy. 무료로 이용하세요.",
    poweredBy: "기반 기술:",
    allTools: "모든 글쓰기 도구",
    citationGuides: "인용 가이드",
    allStyles: "모든 인용 스타일",
    citationGlossary: "인용 용어집",
    howToCiteAny: "모든 자료 인용하는 법",
  },

  faq: {
    heading: "자주 묻는 질문",
    homeQ1: "CitationEasy는 정말 무료인가요?",
    homeA1:
      "네. CitationEasy는 완전히 무료이며 가입도, 사용 제한도, 유료 요금제도 없습니다. {count}개 인용 스타일 전부를 누구나 사용할 수 있습니다.",
    homeQ2: "어떤 인용 스타일을 지원하나요?",
    homeA2:
      "Citation Style Language 프로젝트의 {count}개 스타일 전부이며, APA 7판, MLA 9판, Chicago, Harvard, Vancouver, IEEE, AMA, Turabian 등이 포함됩니다.",
    homeQ3: "계정이 필요한가요?",
    homeA3:
      "아니요. CitationEasy는 전적으로 브라우저에서 실행되고 참고문헌 목록은 사용자 기기에 저장됩니다. 서버로 올라가는 것은 없고 가입할 곳도 없습니다.",
    homeQ4: "참고문헌을 제 언어로 만들 수 있나요?",
    homeA4:
      "네. 참고문헌 언어는 사이트 언어와 별도의 설정이라, 한국어로 작업하면서 논문이 작성된 언어에 맞춰 참고문헌을 만들 수 있습니다.",
    styleQ1: "{style} 인용 생성기는 무료인가요?",
    styleA1:
      "네. {style} 형식 인용 생성은 무료이고 횟수 제한이 없으며 계정도 필요 없습니다. DOI, URL, ISBN 또는 BibTeX 항목을 붙여넣고 완성된 참고문헌을 복사하세요.",
    styleQ2: "{style} 형식으로 자료를 인용하려면 어떻게 하나요?",
    styleA2:
      "자료의 DOI, URL, ISBN 또는 BibTeX 항목을 이 페이지의 생성기에 붙여넣으세요. {style}이(가) 이미 선택되어 있어 참고문헌과 본문 내 인용이 바로 나타납니다.",
    styleQ3: "{style} 서식은 얼마나 정확한가요?",
    styleA3:
      "모든 참고문헌은 Citation Style Language 프로젝트가 배포하는 공식 {style} 정의 — Zotero와 Mendeley가 쓰는 것과 같은 파일 — 로 생성되며, 규칙을 근사한 결과가 아닙니다.",
  },

  tool: {
    modeLabel: "인용 입력 방식",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "도서 검색",
    modeArticles: "논문 검색",
    modeManual: "직접 입력",
    errorEnterManually: "정보를 직접 입력하기",
    autoLabel: "URL, DOI, PMID, arXiv ID, ISBN 또는 BibTeX 붙여넣기",
    autoHint:
      "유형을 자동으로 인식해 메타데이터를 가져옵니다. 한 줄에 하나씩 붙여넣으면 목록 전체를 한 번에 인용할 수 있습니다.",
    generate: "인용 만들기",
    generating: "만드는 중…",
    bookSearchLabel: "제목, 저자 또는 ISBN으로 검색",
    bookSearchEmpty: "아직 결과가 없습니다. ‘검색’을 눌러 도서를 찾아보세요.",
    bookSearchSource: "수백만 권을 수록한 Open Library 목록에서 검색합니다",
    worksSearchLabel: "논문 제목 또는 저자로 검색",
    worksSearchEmpty: "아직 결과가 없습니다. ‘검색’을 눌러 논문을 찾아보세요.",
    worksSearchSource:
      "Crossref 목록에서 검색합니다: 학술지 논문, 학술대회 발표문, 단행본 장",
    showingResults: "{total}건 중 {shown}건 표시",
    search: "검색",
    searching: "검색 중…",
    bulkResults: "일괄 인용 결과",
    copy: "복사",
    copied: "복사했습니다",
    copyHint: "복사해 과제물에 붙여넣으세요",
    resultTitle: "서식이 적용된 인용",
    edit: "편집",
    completeFields: "채우기",
    fieldsIncomplete: "other:{count}개 필드 미완성",
    outputLanguage: "언어",
    sourceType: "자료 유형",
    fieldAuthors: "저자",
    fieldAuthorsHint: "홍길동 또는 Hong, Gildong",
    fieldTitle: "논문 또는 도서 제목",
    fieldBookTitle: "도서 제목",
    fieldBookTitleHint: "단행본 또는 선집의 제목",
    fieldEditors: "편저자",
    fieldJournal: "학술지 / 발행물",
    fieldJournalHint: "학술지 또는 발행물 이름",
    fieldPublisher: "출판사 / 사이트",
    fieldPublisherHint: "출판사 이름 또는 웹사이트",
    fieldDate: "날짜 / 연도",
    fieldVolume: "권",
    fieldIssue: "호",
    fieldPages: "쪽",
    fieldFormat: "형식 / 매체",
    fieldAuthorsGroup: "단체 또는 기관 저자",
    fieldAuthorsGroupHint:
      "단체를 개인과 함께 적으려면 중괄호로 묶으세요: {R Core Team}, Hong, Gildong",
    fieldTranslators: "번역자",
    fieldInterviewers: "인터뷰어",
    fieldVersion: "버전",
    fieldCourt: "법원",
    fieldIssuingAuthority: "발행 기관",
    fieldPatentNumber: "특허 번호",
    fieldEpisodeNumber: "에피소드 번호",
    fieldLawNumber: "법률 또는 법안 번호",
    fieldReportNumber: "보고서 번호",
    fieldReviewedTitle: "서평 대상 저작의 제목",
    fieldReviewedAuthors: "서평 대상 저작의 저자",
    inTextCitation: "본문 내 인용",
    quickEdit: "빠른 편집",
    quickEditHint: "메타데이터를 수정하고 인용을 다시 만듭니다.",
    update: "업데이트",
    saving: "저장 중…",
    fieldAuthor: "저자",
    fieldDateShort: "날짜",
    fieldTitleShort: "제목",
  },

  toolCollections: {
    "citation-generators": "인용 생성기",
    "citation-tools": "인용 및 참고문헌 도구",
    "paper-formatting": "논문 서식",
    "essay-writing": "에세이 및 리포트 작성",
    "writing-analysis": "글쓰기 분석 및 교정",
    "word-counters": "카운터 및 가독성",
    vocabulary: "어휘 및 단어 찾기",
    "research-tools": "연구 및 출판",
    statistics: "통계 계산기",
    math: "수학 계산기",
    science: "과학 및 실험 계산기",
    charts: "차트 및 다이어그램",
    economics: "경제·경영·금융",
    grades: "GPA 및 성적 계산기",
    study: "학습 및 생산성",
    classroom: "교실 및 인쇄용 자료",
    random: "무작위 생성 및 추첨",
    "text-tools": "텍스트 정리 및 서식",
    "fancy-text": "꾸밈 텍스트 및 기호",
    language: "언어 및 음역",
    ciphers: "암호 및 부호",
    converters: "단위·날짜·숫자 변환기",
    developer: "데이터·마크업·코드",
  },
  bib: {
    title: "내 참고문헌 목록",
    studioTitle: "참고문헌 스튜디오",
    studioProjects: "프로젝트",
    studioExplore: "둘러보기",
    studioExploreIntro:
      "가이드, 도구, 모든 인용 스타일이 한 번의 클릭 거리에 있습니다.",
    studioStyleGuide: "{style} 스타일 가이드",
    studioStyleGuideHint: "규칙, 예시, 본문 내 인용 형식",
    studioGenerator: "인용 생성기",
    studioNewProject: "새 프로젝트",
    studioSwitchProject: "프로젝트 전환",
    studioAddSource: "출처 추가",
    studioAddSourceHint:
      "DOI, URL 또는 ISBN을 붙여넣거나 도서와 논문을 검색하거나 직접 입력하세요. 저장한 모든 항목은 이 프로젝트에 들어갑니다.",
    studioDoneAdding: "추가 완료",
    studioReferences: "참고문헌",
    studioReferenceCount: "참고문헌 {count}건",
    studioInspectorTitle: "참고문헌 상세",
    studioInspectorEmpty:
      "참고문헌을 선택하면 본문 내 인용, 메모, 출처 정보를 볼 수 있습니다.",
    studioSavedLocally: "이 브라우저에 저장됨",
    studioOpen: "참고문헌 스튜디오 열기",
    studioViewInStudio: "스튜디오에서 보기",
    studioFooterSaved: "참고문헌 스튜디오에 {count}건 저장됨",
    studioFooterEmpty:
      "저장한 인용은 스튜디오에서 완전한 참고문헌 목록이 됩니다",
    studioClearSelection: "선택 해제",
    studioDeleteSelected: "선택 항목 삭제",
    studioDeleteSelectedBody:
      "“{name}”에서 인용 {count}건을 삭제할까요? 되돌릴 수 없습니다.",
    studioDeletedMany: "인용 {count}건을 삭제했습니다",
    studioMoveTo: "이동 위치",
    studioCopyTo: "복사 위치",
    studioSearchShortcut: "/ 키를 눌러 검색",
    studioStyle: "스타일",
    studioCopyEntry: "항목 복사",
    studioEntryCopied: "항목을 복사했습니다",
    studioSourceDetails: "출처 정보",
    studioEmptyTitle: "이 프로젝트가 비어 있습니다",
    studioEmptyBody:
      "위에서 첫 출처를 추가하거나 기존 BibTeX, RIS, CSL-JSON 라이브러리를 가져오세요.",
    studioBackup: "백업",
    sharedTitle: "공유된 참고문헌 목록",
    save: "저장",
    saving: "저장 중…",
    saved: "저장됨",
    searchPlaceholder: "인용 검색…",
    empty: "저장된 인용이 아직 없습니다",
    emptySearch: "검색과 일치하는 인용이 없습니다.",
    countIn: "{name}: {count}건",
    savedOn: "{date}에 저장",
    emptyInBib:
      "이 참고문헌 목록에는 아직 인용이 없습니다. 인용을 만들어 저장하거나 기존 BibTeX, RIS, CSL-JSON 라이브러리를 가져오세요.",
    savedToast: "인용을 참고문헌 목록에 저장했습니다",
    copyAll: "모두 복사",
    copyAllTitle: "모든 인용 복사",
    export: "내보내기",
    exportTitle: "참고문헌 목록 내보내기",
    import: "가져오기",
    importTitle: "문헌 가져오기",
    importLabel: "문헌 가져오기 (BibTeX, RIS 또는 CSL-JSON)",
    importing: "가져오는 중…",
    importFailed: "가져오기에 실패했습니다. 다시 시도해 주세요.",
    importSummary:
      "가져옴: {added} · 중복 제외: {duplicates} · 한도 초과: {overLimit} · 실패: {failed}",
    importUnreadable: "파일을 읽을 수 없습니다.",
    importUnparseable: "문헌을 가져올 수 없습니다.",
    importReviewTitle: "가져오기 검토",
    importReviewIntro:
      "{total}개의 {format} 문헌을 서식 지정하고 저장하기 전에 검토하세요.",
    importReviewCount: "{total}개 중 {included}개 포함",
    importSelectAll: "모두 포함",
    importExcludeAll: "모두 제외",
    importLimitNotice:
      "200개 항목 제한을 초과한 {count}개의 문헌은 가져오지 않습니다.",
    importDuplicateExisting: "이미 저장된 “{title}”의 중복 가능성",
    importDuplicateBatch: "이번 가져오기의 “{title}”와 중복 가능성",
    importMissingField: "{field} 누락",
    importUntitled: "제목 없는 문헌",
    importReview: "문헌 검토",
    importCommit: "서식 지정 후 가져오기",
    importBack: "뒤로",
    importOutcomeTitle: "가져오기 완료",
    importOutcomeSummary:
      "추가: {added} · 중복 제외: {duplicates} · 선택 제외: {excluded} · 제한 초과: {overLimit} · 실패: {failed}",
    sortBy: "정렬 기준",
    sortTitle: "참고문헌 목록 정렬",
    sortAuthor: "저자 (가나다순)",
    sortNewest: "추가한 날짜 (최신순)",
    sortOldest: "연도 (오래된 순)",
    sortManual: "수동 순서",
    backupAll: "전체 프로젝트 백업 (.json)",
    backupDownloaded: "전체 프로젝트 백업을 다운로드했습니다",
    backupUnreadable: "백업 파일을 읽을 수 없습니다.",
    restore: "복원",
    restoreTitle: "모든 참고문헌 프로젝트 복원",
    restoreWarning:
      "먼저 백업을 검증한 다음 이 브라우저에 저장된 모든 참고문헌을 대체합니다. 이 작업은 취소할 수 없습니다.",
    restoreChoose: "CitationEasy 백업 선택 (.json)",
    replaceAndRestore: "대체하고 복원",
    restoreComplete: "모든 참고문헌 프로젝트를 복원했습니다",
    restoreInvalid: "올바른 CitationEasy 프로젝트 백업이 아닙니다.",
    selectAllVisible: "표시된 항목 모두 선택",
    selectedCount: "{count}개 선택됨",
    clusterOpen: "함께 인용",
    clusterTitle: "복합 본문 내 인용",
    clusterDescription:
      "선택한 참고문헌으로 하나의 인용 클러스터를 만듭니다. 선택한 스타일이 순서, 문장 부호 및 번호 매기기를 결정합니다.",
    clusterTarget: "출력",
    clusterLocatorOptional: "선택적 위치 표시",
    clusterBuildCopy: "인용 만들기 및 복사",
    clusterBuilding: "인용 만드는 중…",
    clusterCopied: "복합 인용이 복사되었습니다",
    clusterFailed: "복합 인용을 만들 수 없습니다. 다시 시도해 주세요.",
    destination: "대상 참고문헌",
    chooseDestination: "참고문헌 선택…",
    copySelected: "복사",
    moveSelected: "이동",
    copyComplete:
      "{count}개 인용을 복사했습니다. 중복 {skipped}개를 건너뛰었습니다.",
    moveComplete:
      "{count}개 인용을 이동했습니다. 중복 {skipped}개는 원본에 남았습니다.",
    selectCitation: "{title} 선택",
    moveUp: "위로 이동",
    moveDown: "아래로 이동",
    deleteTitle: "인용 삭제",
    deleteConfirm: "인용을 삭제할까요?",
    deleted: "인용을 삭제했습니다",
    editTitle: "인용 편집",
    close: "닫기",
    copiedAll: "모든 인용을 복사했습니다",
    copiedAnnotated: "주석 참고문헌 목록을 복사했습니다",
    copiedBibtex: "BibTeX를 복사했습니다",
    copiedBulleted: "글머리 기호 목록을 복사했습니다",
    copiedNumbered: "번호 매기기 목록을 복사했습니다",
    copiedHtml: "HTML 조각을 복사했습니다",
    downloadedWord: "Word 문서를 내려받았습니다",
    downloadedRtf: "RTF 파일을 내려받았습니다",
    downloadedRis: "RIS 파일을 내려받았습니다",
    downloadedCsl: "CSL-JSON 파일을 내려받았습니다",
    downloadedAnnotated: "주석 참고문헌 목록을 내려받았습니다",
    copyFailed: "클립보드에 복사하지 못했습니다",
    shareCopied:
      "링크를 복사했습니다. 링크가 있는 사람은 이 목록을 보고 가져올 수 있습니다.",
    shareFailed: "공유 링크를 만들지 못했습니다",
    regenerateFailed: "인용을 다시 만들지 못했습니다",
    updateFailed: "인용을 업데이트하지 못했습니다",
    fieldAuthor: "저자",
    fieldTitle: "제목",
    fieldDate: "날짜",
    fieldPublisher: "출판사",
    fieldVolume: "권",
    fieldIssue: "호",
    fieldPages: "쪽",
    fieldUrl: "URL",
    fieldAccessed: "접속일",
    fieldEditor: "편집자",
    fieldEvent: "행사 장소",
    noteLabel: "이 자료에 대한 주석",
    noteEdit: "이 메모 편집",
    notePlaceholder:
      "자료를 요약하고 평가한 뒤, 과제와 어떻게 연결되는지 적어 보세요…",
    noteRemoved: "메모를 삭제했습니다",
    noteSave: "메모 저장",
    noteCancel: "취소",
    noteAdd: "메모 추가",
    noteWords: "{count} 단어",
    noteSaved: "메모를 저장했습니다 ({count} 단어)",
    noteClickToEdit: "클릭해 편집",
    inTextCopy: "이 자료의 본문 내 인용 복사",
    inTextSelect: "복사하려면 아래 인용을 선택하세요.",
    inTextFailed: "본문 내 인용을 만들지 못했습니다. 다시 시도해 주세요.",
    locator: "위치 표시",
    locatorType: "위치 유형",
    locatorPage: "쪽",
    locatorChapter: "장",
    locatorSection: "절",
    locatorParagraph: "문단",
    locatorLine: "행",
    locatorVerse: "절(운문)",
    reformat: "다시 서식 적용",
    reformatTitle: "모든 인용을 다른 스타일로 다시 만들기",
    reformatHeading: "전체를 하나의 스타일로 통일",
    reformatChoose: "스타일 선택…",
    reformatFailed: "다시 서식을 적용하지 못했습니다. 목록은 그대로입니다.",
    sortOrder: "정렬 기준",
    copyToClipboard: "클립보드에 복사",
    numberedList: "번호 매기기 목록",
    bulletedList: "글머리 기호 목록",
    htmlSnippet: "HTML 조각",
    copyWithAnnotations: "주석과 함께 복사",
    wordAnnotated: "주석이 있는 Word 문서(.doc)",
    downloadFile: "파일 내려받기",
    wordDocument: "Word 문서(.doc)",
    copyShareLink: "공유 링크 복사",
    print: "인쇄…",
    printFailed: "팝업이 차단되었습니다. 인쇄하려면 팝업을 허용하세요",
    font: "글꼴",
    sitePublication: "사이트 / 출판물 이름",
    importIntro:
      "BibTeX(.bib), RIS(.ris) 또는 CSL-JSON(.json)을 붙여넣거나 파일을 올리세요",
    importUpload: ".bib, .ris 또는 .json 파일 올리기",
    importPaste: "또는 BibTeX, RIS, CSL-JSON 붙여넣기",
    cancel: "취소",
    done: "완료",
    delete: "삭제",
    deleteBody: "이 인용이 참고문헌 목록에서 영구히 삭제됩니다.",
    editBody: "메타데이터를 수정하고 저장하면 인용이 다시 만들어집니다.",
    reformatExplain:
      "저장된 자료 데이터로 {count}건 전체를 다시 만듭니다 — 다시 내려받지 않으며 자료가 사라지지 않습니다.",
    inTextHeading: "본문 내 인용",
    inTextLocatorHint:
      "쪽 번호 등 위치를 추가하면 자료의 특정 지점을 가리키는 인용이 됩니다 — 직접 인용할 때 대부분의 스타일이 요구합니다. 단순한 형태를 원하면 비워 두세요.",
    inTextCopyButton: "본문 내 인용 복사",
    mixedStyles:
      "이 참고문헌 목록에는 {count}가지 인용 스타일이 섞여 있습니다({styles}).",
    mixedStylesAction: "제출 전에 {action}을 눌러 하나의 스타일로 통일하세요.",
    selectBibliography: "참고문헌 목록 선택",
    newBibliography: "새 참고문헌 목록",
    moreOptions: "추가 옵션",
    rename: "이름 바꾸기",
    removeDuplicates: "중복 삭제",
    cannotDeleteOnly: "유일한 참고문헌 목록은 삭제할 수 없습니다",
    newBibliographyBody: "다른 과제나 프로젝트용 참고문헌 목록을 만드세요.",
    bibliographyName: "참고문헌 목록 이름",
    create: "만들기",
    renameBibliography: "참고문헌 목록 이름 바꾸기",
    renameBibliographyBody: "“{name}”의 새 이름을 입력하세요.",
    newName: "새 이름",
    duplicateRemovedOne: "중복 {count}개를 삭제했습니다",
    duplicateRemovedMany: "중복 {count}개를 삭제했습니다",
    noDuplicates: "중복 참고문헌이 없습니다",
    removeDuplicatesConfirm: "중복 참고문헌을 삭제할까요?",
    removeDuplicatesBody:
      "“{name}”에서 같은 자료를 DOI, ISBN 또는 제목·연도·저자로 찾아 한 개만 남깁니다. 일치 여부를 판단할 수 없는 자료는 그대로 둡니다.",
    deleteBibliographyConfirm: "참고문헌 목록을 삭제할까요?",
    deleteBibliographyBody:
      "“{name}”과 그 안의 인용 {count}개가 영구적으로 삭제됩니다.",
  },

  bibliographyPage: {
    metaTitle: "참고문헌 스튜디오 - 인용 정리, 주석, 내보내기",
    metaDescription:
      "브라우저에서 비공개 참고문헌 프로젝트를 관리하세요. 계정 없이 검색, 정렬, 주석, 편집, 재서식, 가져오기, 내보내기와 공유가 가능합니다.",
    keyword1: "참고문헌 만들기",
    keyword2: "인용 관리",
    keyword3: "주석 참고문헌 도구",
    ogTitle: "참고문헌 스튜디오",
    ogDescription:
      "인용을 정리하고 서식을 지정하며 주석을 달고 가져오거나 내보내는 비공개 전체 화면 작업 공간입니다.",
    ogImageTitle: "참고문헌 스튜디오",
    ogImageSubtitle:
      "참고문헌을 정리하고 주석을 달며 재서식, 내보내기, 공유하세요.",
    ogKind: "인용 작업 공간",
    breadcrumb: "참고문헌 스튜디오",
    eyebrow: "브라우저 기반 비공개 작업 공간",
    lead: "논문의 모든 참고문헌을 한곳에서 관리하세요. 직접 내보내거나 공유하지 않는 한 프로젝트는 이 브라우저에만 남습니다.",
    privacyTitle: "기본적으로 비공개",
    privacyBody:
      "프로젝트와 주석은 브라우저 로컬 저장소를 사용합니다. 공유 링크에는 인용이 포함되지만 비공개 메모는 의도적으로 제외됩니다.",
    workflowTitle: "자료 목록에서 최종 논문까지",
    workflowBody:
      "프로젝트를 전환하고 참고문헌을 검색·정렬하며 주석이나 위치를 추가하고 메타데이터를 수정한 뒤 전체 목록을 한 스타일로 재서식하세요.",
    formatsTitle: "참고문헌을 가져오고 어디서나 활용",
    formatsBody:
      "BibTeX, RIS 또는 CSL-JSON을 가져오세요. 서식 있는 목록을 복사하거나 Word, RTF, RIS, CSL-JSON, HTML, BibTeX와 주석 버전을 내보낼 수 있습니다.",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term} - 정의와 예시",
    notFoundTitle: "용어를 찾을 수 없습니다",
    keywordDefinition: "{term} 정의",
    keywordWhatIs: "{term}이란",
    ogTitle: "{term} - CitationEasy 용어집",
    ogKind: "인용 용어집",
    breadcrumb: "용어집",
    alsoCalled: "다른 이름: {aliases}",
    doItHeading: "CitationEasy에서 해보기",
    seeAlsoHeading: "관련 용어",
    moreInHeading: "{category}의 다른 용어",
    navLabel: "용어집 탐색",
    allTermsLink: "전체 {count}개 용어집 보기",
    generatorLink: "무료 인용 생성기",
    termSetName: "CitationEasy 인용 용어집",
    hubMetaTitle: "인용 용어집 - {count}개 용어 설명",
    hubMetaDescription:
      "et al., ibid., DOI, 내어쓰기, 짜깁기, 최종본 등 {count}개의 인용·학술 글쓰기 용어를 평이한 말로 설명하고, 각각 예시를 함께 제공합니다.",
    hubKeyword1: "인용 용어집",
    hubKeyword2: "인용 용어",
    hubKeyword3: "학술 글쓰기 용어집",
    hubKeyword4: "et al 뜻",
    hubKeyword5: "DOI란",
    hubKeyword6: "참고문헌 용어",
    hubOgTitle: "인용 용어집",
    hubOgDescription:
      "{count}개의 인용·학술 글쓰기 용어를 예시와 함께 설명합니다.",
    hubOgImageTitle: "인용 용어집",
    hubOgImageSubtitle:
      "{count}개의 인용·학술 글쓰기 용어를 평이한 말과 예시로 설명합니다.",
    hubOgKind: "참고 자료",
    hubTermSetDescription:
      "{count}개의 인용, 참고문헌, 학술 글쓰기 용어에 대한 정의입니다.",
    hubCollectionName: "인용 용어집",
    hubCollectionDescription:
      "{count}개의 인용·학술 글쓰기 용어를 평이한 말로 설명합니다.",
    hubHeading: "인용 용어집",
    hubIntro:
      "인용과 학술 글쓰기에 관한 {count}개 용어를 평이한 말과 예시로 설명합니다. 스타일 가이드에 등장하는 약어, 참고문헌을 구성하는 요소, 자료를 특정하는 식별자, 그리고 학술 출판 용어를 다룹니다.",
    hubJumpLabel: "첫 글자로 이동",
    hubBrowseHeading: "주제별로 보기",
    hubAllHeading: "전체 용어 (A–Z)",
    hubWorkHeading: "용어를 직접 활용해 보세요",
    hubWorkGenerator: "무료 인용 생성기",
    hubWorkStyles: "인용 스타일 가이드",
    hubWorkHowTo: "모든 자료 인용 방법",
    hubWorkCompare: "인용 스타일 비교",
    hubWorkTools: "글쓰기·인용 도구",
    hubWorkFaq: "인용 FAQ",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle: "인용 FAQ - 자주 묻는 인용 질문에 대한 빠른 답변",
    metaDescription:
      "DOI, 저자 없는 자료, et al., 내어쓰기, AI 인용, 표절 규정, APA와 MLA의 차이 등 학생들이 실제로 궁금해하는 인용 질문에 빠르고 정확하게 답합니다. 상세 가이드로 연결되는 링크도 함께 제공합니다.",
    ogTitle: "인용 FAQ",
    ogDescription:
      "DOI와 et al.부터 ChatGPT 인용까지, 가장 자주 나오는 인용 질문에 대한 빠른 답변입니다.",
    ogImageTitle: "인용 질문과 답변",
    ogImageSubtitle:
      "학생들이 실제로 궁금해하는 인용 질문에 짧고 정확하게 답합니다.",
    ogKind: "FAQ",
    breadcrumbLabel: "이동 경로",
    breadcrumbHome: "홈",
    breadcrumbCurrent: "인용 FAQ",
    heading: "인용 FAQ",
    intro:
      "학생들이 실제로 궁금해하는 인용 질문에 빠르고 정확하게 답합니다. 더 자세히 알고 싶다면 전체 가이드나 도구로 연결되는 링크를 이용하세요.",
    contentsLabel: "FAQ 목차",
    stillStuckHeading: "그래도 궁금증이 풀리지 않나요?",
    stillStuckBody:
      "[전체 가이드 라이브러리](/guides)를 둘러보거나, [스타일별 치트시트](/cheat-sheets)를 확인하거나, [인용 용어집](/glossary)에서 용어를 찾아보거나, [사이트 전체를 검색](/search)하거나, 그냥 [인용을 생성](/)해서 서식 규칙을 자동으로 적용받을 수도 있습니다.",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle: "인용 스타일 치트시트 - 빠른 참고 가이드",
    hubMetaDescription:
      "APA, MLA, 시카고 인용 스타일을 위한 빠른 참고용 치트시트입니다. 흔한 자료 유형 예시가 포함된 인쇄하기 좋은 가이드입니다.",
    hubBreadcrumbHome: "홈",
    hubBreadcrumbCurrent: "인용 스타일 치트시트",
    hubBackLink: "← 생성기로 돌아가기",
    hubHeading: "인용 스타일 치트시트",
    hubIntro:
      "가장 많이 쓰이는 인용 스타일을 위한 빠른 참고 가이드입니다. 인쇄하기 좋으며 항상 최신 상태로 유지됩니다.",
    hubApaTitle: "APA 7판 치트시트",
    hubApaDesc: "심리학, 사회과학, 교육학, 간호학",
    hubMlaTitle: "MLA 9판 치트시트",
    hubMlaDesc: "문학, 어학, 인문학, 문화 연구",
    hubChicagoTitle: "시카고 스타일 치트시트",
    hubChicagoDesc: "역사학, 미술사, 철학, 종교학",
    backToSheets: "← 치트시트 목록으로 돌아가기",
    generalRules: "기본 규칙",
    inTextCitations: "본문 내 인용",
    colSituation: "상황",
    colFormat: "형식",
    colExample: "예시",
    book: "도서",
    journalArticle: "학술지 논문",
    website: "웹사이트",
    apaMetaTitle: "APA 7판 치트시트 - 빠른 참고 가이드",
    apaMetaDescription:
      "도서, 학술지, 웹사이트 등의 예시가 포함된 APA 7판 인용 치트시트입니다. 인쇄하기 좋은 빠른 참고용입니다.",
    apaHeading: "APA 7판 치트시트",
    apaLead: "가장 흔한 APA 인용 형식에 대한 빠른 참고 자료입니다.",
    apaRule1:
      "**내어쓰기**를 사용한다 (첫 줄은 왼쪽에 맞추고, 이후 줄은 0.5인치 들여쓴다)",
    apaRule2: "모든 항목을 두 줄 간격으로 작성한다",
    apaRule3: "저자 성의 알파벳순으로 정렬한다",
    apaRule4: "도서, 학술지, 권호의 제목은 기울임꼴로 표기한다",
    apaRule5: "DOI가 있으면 사용한다",
    apaRow1Situation: "저자 1인",
    apaRow1Format: "(Author, Year)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "저자 2인",
    apaRow2Format: "(Author & Author, Year)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "저자 3인 이상",
    apaRow3Format: "(First Author et al., Year)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "직접 인용",
    apaRow4Format: "(Author, Year, p. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "저자 없음",
    apaRow5Format: '("Title," Year)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "참고문헌 목록 예시",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "편저서의 장",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "학술대회 논문",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "APA 6판과의 주요 차이점",
    apaDifference1: 'URL 앞에 "Retrieved from"을 붙이지 않는다',
    apaDifference2: "DOI는 https://doi.org/ 링크 형식으로 포함한다",
    apaDifference3: "저자는 최대 20명까지 나열한 뒤 줄임표를 사용한다",
    apaDifference4: "출판사 소재지는 더 이상 필요하지 않다",
    apaDifference5: '성 중립적 표현에는 단수형 "they"를 사용한다',
    apaCtaText: "APA 인용을 자동으로 정확하게 생성하기",
    apaCtaButton: "APA 인용 생성기 →",
    mlaMetaTitle: "MLA 9판 치트시트 - 빠른 참고 가이드",
    mlaMetaDescription:
      "도서, 논문, 웹사이트 등의 예시가 포함된 MLA 9판 인용 치트시트입니다. 인쇄하기 좋은 빠른 참고용입니다.",
    mlaHeading: "MLA 9판 치트시트",
    mlaLead: "가장 흔한 MLA 인용 형식에 대한 빠른 참고 자료입니다.",
    mlaRule1: "**내어쓰기**를 사용한다",
    mlaRule2: "모든 항목을 두 줄 간격으로 작성한다",
    mlaRule3: "저자 성의 알파벳순으로 정렬한다",
    mlaRule4: '페이지 제목을 "인용문헌"으로 한다',
    mlaRule5: "컨테이너(도서, 학술지, 웹사이트)의 제목은 기울임꼴로 표기한다",
    mlaRow1Situation: "저자 1인",
    mlaRow1Format: "(Author Page)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "저자 2인",
    mlaRow2Format: "(Author and Author Page)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "저자 3인 이상",
    mlaRow3Format: "(First Author et al. Page)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "저자 없음",
    mlaRow4Format: '("Title" Page)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "쪽 번호 없음",
    mlaRow5Format: "(Author)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "인용문헌 예시",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "선집·편저서",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "MLA 핵심 요소 (순서대로)",
    mlaCore1: "Author.",
    mlaCore2: '"Title of Source."',
    mlaCore3: "*Title of Container*,",
    mlaCore4: "Contributors,",
    mlaCore5: "Version,",
    mlaCore6: "Number,",
    mlaCore7: "Publisher,",
    mlaCore8: "Publication date,",
    mlaCore9: "Location (pages, URL, DOI).",
    mlaCtaText: "MLA 인용을 자동으로 정확하게 생성하기",
    mlaCtaButton: "MLA 인용 생성기 →",
    chicagoMetaTitle: "시카고 스타일 치트시트 - 빠른 참고 가이드",
    chicagoMetaDescription:
      "주석·서지 방식과 저자·연도 방식 예시가 포함된 시카고 매뉴얼 오브 스타일 인용 치트시트입니다. 인쇄하기 좋은 빠른 참고용입니다.",
    chicagoHeading: "시카고 스타일 치트시트",
    chicagoLead:
      "시카고 매뉴얼 오브 스타일(18판) 인용 형식에 대한 빠른 참고 자료입니다.",
    chicagoSystemsHeading: "시카고의 두 가지 방식",
    chicagoColNb: "주석·서지 방식 (NB)",
    chicagoColAd: "저자·연도 방식 (AD)",
    chicagoRow1Nb: "각주·후주 + 서지",
    chicagoRow1Ad: "괄호 인용 + 참고문헌 목록",
    chicagoRow2Nb: "역사학, 예술, 인문학",
    chicagoRow2Ad: "과학, 사회과학",
    chicagoRow3Nb: "첫 주석이 더 상세함",
    chicagoRow3Ad: "APA 형식과 유사",
    chicagoExamplesHeading: "주석·서지 방식 예시",
    chicagoNoteLabel: "주석:",
    chicagoBibliographyLabel: "서지:",
    chicagoBookLabel: "도서 (각주)",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "학술지 논문 (각주)",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "웹사이트 (각주)",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "축약 주석",
    chicagoShortIntro: "최초의 전체 인용 이후에는 축약된 각주를 사용합니다:",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "주요 서식 규칙",
    chicagoRule1: "본문의 각주 참조에는 위 첨자 숫자를 사용한다",
    chicagoRule2: "서지 항목에는 내어쓰기를 사용한다",
    chicagoRule3:
      '같은 자료를 연속으로 인용할 때도 "Ibid." 대신 축약 각주를 사용한다',
    chicagoRule4:
      "제목: 도서와 학술지는 기울임꼴로, 논문과 장 제목은 따옴표로 표기한다",
    chicagoRule5: "변경될 수 있는 온라인 자료에는 접속일을 기재한다",
    chicagoCtaText: "시카고 스타일 인용을 자동으로 정확하게 생성하기",
    chicagoCtaButton: "시카고 인용 생성기 →",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "주요 페이지",
    styleLanding: "주요 인용 스타일 허브",
    style: "인용 스타일 참조 페이지",
    styleExamples: "인용 예시 페이지",
    styleFormat: "논문 서식 가이드",
    styleInText: "본문 내 인용 가이드",
    styleAnnotatedBibliography: "주석 참고문헌 목록 가이드",
    styleReferencePage: "참고문헌·인용문헌 페이지 가이드",
    tool: "무료 글쓰기·인용 도구",
    guide: "학습 가이드",
    guideCategory: "가이드 카테고리",
    toolCollection: "도구 모음",
    howToCite: "<style>에서 <source> 인용하는 방법",
    comparison: "인용 스타일 비교",
    converter: "식별자·형식 변환기",
    field: "학문 분야별 인용 스타일",
    region: "국가·지역별 인용 스타일",
    category: "주제별 인용 스타일",
    cheatSheet: "한 페이지 치트시트",
    glossary: "인용 및 학술 글쓰기 용어집",
  },

  // /about
  aboutPage: {
    metaTitle: "CitationEasy 소개 - 무료 인용 생성기",
    metaDescription:
      "CitationEasy는 {count}가지 스타일을 지원하는 무료 인용 생성기입니다. Citation Style Language, Citation.js, Next.js 등 오픈소스 도구를 사용해 Samuel Sergi가 만들었습니다.",
    backLink: "← 생성기로 돌아가기",
    heading: "CitationEasy 소개",
    intro:
      "CitationEasy는 학생, 연구자, 학술 저술가를 위해 만들어진 무료 오픈 액세스 인용 생성기입니다. **{count}가지 인용 스타일**을 지원하며, 가입이나 구독 없이도 계속 늘어나는 글쓰기 도구, 학습 가이드, 참고 자료를 제공합니다.",
    offerHeading: "제공하는 기능",
    offer1:
      "APA 7판, MLA 9판, 시카고 18판, 하버드, 밴쿠버, IEEE를 포함해 {count}가지 스타일을 지원하는 [인용 생성기](/)",
    offer2:
      "단어 수 세기, 가독성 검사, DOI 검증 도구, 참고문헌 알파벳순 정렬 등 [무료 글쓰기·인용 도구 40가지](/tools)",
    offer3:
      "6가지 인용 스타일에 걸쳐 주요 자료 유형을 모두 다루는 [인용 방법 가이드 750개](/how-to-cite)",
    offer4:
      "인용 모범 사례, 학술 글쓰기, 연구 능력에 관한 [학습 가이드 100개 이상](/guides)",
    offer5:
      "빠르게 참고할 수 있는 [스타일 비교 도구](/compare), [인용 스타일 퀴즈](/quiz), [치트시트](/cheat-sheets)",
    offer6:
      "일반 텍스트, BibTeX, Word, 번호 목록, 글머리 기호 목록, RIS, CSV까지 7가지 내보내기 형식",
    openSourceHeading: "오픈소스로 만들었습니다",
    openSourceIntro:
      "CitationEasy는 여러 훌륭한 오픈소스 프로젝트와 API 덕분에 만들어질 수 있었습니다. 이 자리를 빌려 감사를 전합니다.",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) — 저희가 지원하는 {count}가지 인용 스타일을 뒷받침하는 공개 표준입니다. CSL은 자원봉사자 커뮤니티가 관리하며, Zotero, Mendeley, Papers 같은 참고문헌 관리 도구에서도 사용됩니다. 스타일 정의는 GitHub의 [CSL Styles Repository](https://github.com/citation-style-language/styles)에서 가져옵니다.",
    openSource2:
      "[Citation.js](https://citation.js.org/) — 인용을 처리하고 CSL 스타일에 따라 서식을 적용하는 자바스크립트 라이브러리입니다. Lars Willighagen이 만들었습니다.",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) — Internet Archive가 제공하는 무료 도서 검색 API로, 제목이나 ISBN으로 도서 메타데이터를 조회할 때 사용합니다.",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) — DOI를 확인하고 검증하는 데 사용하는 디지털 객체 식별자(Digital Object Identifier) 시스템입니다.",
    createdHeading: "만든 사람",
    createdBody:
      "CitationEasy는 **Samuel Sergi**가 만들고 운영하고 있습니다. 목표는 단순합니다. 유료 장벽 뒤에 기능을 숨기거나 계정 생성을 요구하지 않는, 진짜 무료이면서 품질 좋은 인용 도구를 제공하는 것입니다.",
    contactPrompt: "질문이나 의견, 제안이 있으신가요? 언제든 연락해 주세요:",
    contactEmail: "이메일: [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "우리의 사명",
    mission1:
      "정확한 인용에 돈이 들어서는 안 됩니다. 많은 인용 도구가 무료라고 광고하면서도 내보내기 형식을 제한하거나 인용 개수를 제한하고, 유료 플랜을 유도합니다. CitationEasy는 완전 무료를 지향합니다. 가입도, 제한도, 유료 등급도 없습니다.",
    mission2:
      "인용 생성기부터 글쓰기 도구, 학습 가이드까지 이 사이트의 모든 기능은 누구나 무료로 이용할 수 있습니다. 저희는 학문적 진실성을 지키는 도구가 예산과 상관없이 모든 학생과 연구자에게 열려 있어야 한다고 믿습니다.",
  },

  // /contact
  contactPage: {
    metaTitle: "문의하기",
    metaDescription:
      "CitationEasy에 문의해 주세요. 무료 인용 생성기와 글쓰기 도구에 대한 질문, 의견, 제안을 기다리고 있습니다.",
    backLink: "← 생성기로 돌아가기",
    heading: "문의하기",
    intro:
      "CitationEasy에 대해 질문이나 의견, 제안이 있으신가요? 언제든 연락해 주세요. 오류를 발견했거나, 원하는 기능이 있거나, 인용에 도움이 필요하시다면 편하게 연락 주시기 바랍니다.",
    touchHeading: "연락 방법",
    touchBody:
      "가장 확실한 연락 방법은 이메일입니다. 48시간 이내 답변을 목표로 하고 있습니다.",
    emailLine: "**이메일:** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "자주 묻는 질문",
    commonIntro:
      "문의하시기 전에, 아래 자료에서 궁금하신 답을 찾을 수도 있습니다.",
    resource1:
      "[인용 가이드](/guides) — 주요 스타일별로 자료를 인용하는 방법을 단계별로 안내",
    resource2:
      "[인용 방법 가이드](/how-to-cite) — 자료 유형과 스타일의 750가지 조합을 예시와 함께 소개",
    resource3:
      "[치트시트](/cheat-sheets) — APA, MLA, 시카고 서식을 빠르게 확인할 수 있는 요약표",
    resource4:
      "[글쓰기 도구](/tools) — 단어 수 세기, 가독성 검사, DOI 검증 도구 등",
    issueHeading: "문제 신고",
    issueIntro:
      "인용 서식 오류, 기능 오작동, 잘못된 스타일을 발견하셨다면 문의하실 때 다음 정보를 최대한 자세히 알려 주세요.",
    issue1: "사용하고 계셨던 인용 스타일",
    issue2: "자료 유형 (도서, 웹사이트, 학술지 논문 등)",
    issue3: "예상했던 결과와 실제 생성된 결과의 차이",
    issue4: "사용 중인 브라우저와 기기 (관련이 있는 경우)",
    issueOutro: "이 정보가 있으면 문제를 빠르게 파악하고 해결할 수 있습니다.",
    aboutHeading: "CitationEasy 소개",
    aboutBody:
      "CitationEasy는 10,000가지가 넘는 인용 스타일을 지원하는 무료 인용 생성기입니다. 정확한 인용을 누구나 이용할 수 있도록 한다는 목표로 Samuel Sergi가 만들었습니다. 자세한 내용은 [소개 페이지](/about)에서 확인하세요.",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle:
      "AI 어시스턴트와 에이전트를 위한 CitationEasy - API, MCP 서버, llms.txt",
    metaDescription:
      "CitationEasy를 프로그래밍 방식으로 이용하세요: {count}가지 스타일의 인용을 처리하는 무료 무인증 JSON API, 에이전트용 MCP 서버, llms.txt, OpenAPI 명세, 그리고 모든 페이지의 마크다운 뷰를 제공합니다.",
    keyword1: "인용 API",
    keyword2: "MCP 서버",
    keyword3: "인용 생성기 API",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "AI 에이전트 인용",
    keyword7: "무료 인용 API",
    webApiDescription:
      "URL, DOI, ISBN, PubMed ID, arXiv ID 또는 CSL-JSON 메타데이터로부터 {count}가지 Citation Style Language 스타일의 인용을 서식화하는 무료 무인증 JSON API입니다.",
    breadcrumb: "AI·에이전트용",
    heading: "AI 어시스턴트와 에이전트를 위한 CitationEasy",
    intro:
      "이 사이트의 모든 기능은 사람뿐 아니라 소프트웨어에서도 이용할 수 있습니다. 무료 JSON API, MCP 서버, OpenAPI 명세, llms.txt 색인, 그리고 전체 {count}개 페이지의 마크다운 뷰를 제공합니다. 키도, 계정도, 자체 요청 제한도 없습니다.",
    whyHeading: "직접 인용을 작성하는 대신 API를 호출해야 하는 이유",
    whyBody:
      "인용 서식 적용은 텍스트 생성 문제처럼 보이지만 실제로는 그렇지 않습니다. 스타일마다 저자명 도치, 이니셜 표기, 제목 대소문자, 컨테이너 구두점, 판 표기, 날짜 위치에 관한 수백 가지 규칙이 정해져 있으며, 그 차이는 기억에 의존해 쓰면 미묘하게 틀리기 쉽습니다. CitationEasy는 공식 Citation Style Language 정의를 대상으로 **citeproc-js**를 실행합니다. 이는 Zotero와 Mendeley가 사용하는 것과 같은 엔진으로, 출력이 결정적이며 학술지 투고 시스템이 요구하는 형식과 일치합니다. 메타데이터는 Crossref, Open Library, PubMed에서 가져오며, 아무것도 지어내지 않습니다. 원본에 없는 항목은 그럴듯한 추측으로 채우지 않고 그대로 비워 둡니다.",
    generateHeading: "인용 생성하기",
    generateBody:
      "한 번의 호출로 최대 10개 자료를 처리하려면 `input` 대신 `inputs`를 보내세요. 이미 가지고 있는 CSL-JSON 메타데이터가 있다면 `entry`를 사용해 조회 과정을 완전히 건너뛸 수 있습니다. 각주 형식이 필요하면 `note: true`를 추가하세요. 자료별 오류는 해당 자료에 대해서만 반환되므로, 일괄 처리 전체가 실패하는 일은 없습니다.",
    mcpHeading: "MCP로 연결하기",
    mcpIntro:
      "`/api/mcp`에 있는 Model Context Protocol 엔드포인트는 스트리밍 가능한 HTTP를 통해 JSON-RPC 2.0을 사용하며 별도의 인증 정보가 필요 없습니다.",
    mcpToolsHeading: "제공하는 도구",
    endpointsHeading: "엔드포인트",
    colEndpoint: "엔드포인트",
    colWhat: "기능",
    endpointCite:
      "최대 10개 자료를 한 번에 서식화합니다. URL, DOI, ISBN, PubMed ID, arXiv ID, BibTeX/RIS/CSL-JSON 텍스트 또는 CSL-JSON 항목 객체를 받습니다. 참고문헌 항목과, 필요에 따라 본문 내 인용과 각주도 함께 반환합니다.",
    endpointStyles:
      "이름, 인용 서식 클래스, 학문 분야, 지역으로 {count}가지 스타일 전체를 검색합니다.",
    endpointStyleSlug:
      "스타일 하나를 자세히, 해당 CSL 정의로 직접 생성한 실제 서식 예시와 함께 반환합니다.",
    endpointSearch: "사이트 내 모든 페이지를 대상으로 한 관련도순 검색입니다.",
    endpointPages:
      "사이트 전체 카탈로그를 구조화된 항목으로 제공하며, 페이지 유형으로 필터링할 수 있습니다.",
    endpointHowToCite:
      "자료 유형 × 스타일별 모든 안내 페이지이며, 둘 중 무엇으로도 필터링할 수 있습니다.",
    endpointTools: "모든 무료 도구를, 카테고리와 키워드와 함께 제공합니다.",
    endpointGuides: "모든 학습 가이드를, 카테고리와 함께 제공합니다.",
    endpointConverters: "사이트가 제공하는 모든 식별자·형식 변환입니다.",
    endpointComparisons:
      "두 스타일의 레코드에 모두 연결된, 나란히 비교하는 스타일 비교입니다.",
    endpointFields:
      '"어떤 스타일을 써야 하나요?"라는 질문에 답하기 위한 학문 분야, 주제 카테고리, 지역 정보입니다.',
    endpointFaq:
      "자주 나오는 인용 질문에 대한 검증된 답변이며, q로 필터링할 수 있습니다.",
    endpointGlossary:
      "인용·학술 글쓰기 용어와 그 전체 정의입니다. 응답 자체에 텍스트가 담겨 있어 이후에 별도 페이지를 조회할 필요가 없습니다.",
    endpointIndex:
      "엔드포인트 탐색 문서입니다. 처음 살펴보신다면 여기서 시작하세요.",
    discoveryHeading: "탐색용 파일",
    discoveryLlms: "언어 모델을 위해 작성된, 사이트의 엄선된 색인입니다.",
    discoveryLlmsFull:
      "사이트가 게시하는 모든 페이지를 유형별로 한 줄씩 정리한 것입니다.",
    discoveryOpenapi: "전체 공개 API에 대한 OpenAPI 3.1 설명입니다.",
    discoveryMcp:
      "MCP 엔드포인트(스트리밍 가능한 HTTP)입니다. 브라우저에서 GET하면 설명이 표시됩니다.",
    discoveryWellKnownMcp:
      "도메인을 탐색하는 에이전트를 위한 MCP 탐색 문서입니다.",
    discoveryAiPlugin:
      "여전히 이를 찾는 프레임워크를 위한 레거시 플러그인 매니페스트입니다.",
    discoveryMd: "사이트 내 모든 페이지의 마크다운 뷰입니다.",
    discoverySitemap: "색인 가능한 모든 URL입니다.",
    catalogHeading: "카탈로그에 담긴 내용",
    catalogIntro:
      "아래의 모든 페이지는 HTML로도, `/md/` 아래의 마크다운으로도, `/api/v1/pages`의 구조화된 항목으로도 접근할 수 있습니다.",
    catalogStyles:
      "**{count}**가지 인용 스타일, 각각 자체 CSL 정의로 생성한 실제 예시 포함",
    catalogTools: "**{count}**개의 무료 브라우저 도구",
    catalogGuides: "**{count}**개의 학습 가이드",
    catalogHowToCite: "**{count}**개의 인용 방법 페이지",
    catalogComparisons: "**{count}**개의 스타일 비교",
    catalogConverters: "**{count}**개의 변환기",
    catalogFields: "**{count}**개의 학문 분야",
    catalogStyleLandings:
      "완전한 서식 규칙을 갖춘 **{count}**개의 주요 스타일 허브",
    faqHeading: "자주 묻는 질문",
    faqFreeQ: "CitationEasy API는 무료인가요? API 키가 필요한가요?",
    faqFreeA:
      "무료이며 API 키가 필요 없습니다. /api/v1 아래의 모든 엔드포인트는 인증이 필요 없고 CORS가 열려 있어, 등록 없이 브라우저, 노트북, 에이전트에서 호출할 수 있습니다. 자체 요청 제한은 없지만, 식별자 조회는 Crossref, Open Library, PubMed를 통해 프록시되며 각자 고유의 공정 이용 제한을 적용합니다. 여러 요청을 동시에 보내는 대신 `inputs`로 일괄 처리하세요.",
    faqLlmQ: "인용은 언어 모델이 생성하나요?",
    faqLlmA:
      "아닙니다. 서식 적용은 참고문헌 관리 프로그램이 사용하는 것과 같은 엔진인 citeproc-js를 공식 Citation Style Language 정의에 대해 실행하는 방식으로 이루어집니다. 같은 입력과 스타일은 항상 같은 결과 문자열을 만듭니다. 서지 메타데이터는 Crossref(DOI), Open Library(ISBN), PubMed(PMID)에서 가져옵니다. CitationEasy는 항목을 지어내지 않으므로, 원본에 없는 정보는 추측하지 않고 출력에서도 비워 둡니다.",
    faqMcpQ: "에이전트를 MCP로 CitationEasy에 연결하려면 어떻게 하나요?",
    faqMcpA:
      "어떤 Model Context Protocol 클라이언트든 스트리밍 가능한 HTTP 전송을 사용해 https://www.citationeasy.com/api/mcp로 연결하세요. 별도의 인증 정보는 필요 없습니다. Claude Code에서는: `claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`. 이 서버는 인용 생성, {count}가지 스타일 검색, 자료 유형별 안내, 사이트 검색, 그리고 모든 페이지를 마크다운으로 읽는 도구를 제공합니다.",
    faqStylesQ: "이 API는 어떤 인용 스타일을 만들 수 있나요?",
    faqStylesA:
      'Citation Style Language 저장소에 있는 {count}가지 스타일 전체를 지원합니다. APA 7, MLA 9, 두 가지 시카고 방식, 하버드, 밴쿠버, IEEE, AMA는 물론 수천 개의 개별 학술지 스타일도 포함됩니다. `style` 필드에 스타일 슬러그를 전달하세요. "chicago"나 "harvard" 같은 알기 쉬운 슬러그는 올바른 CSL 변형으로 해석되며, 나머지는 /api/v1/styles?q=로 찾을 수 있습니다.',
    faqLlmsTxtQ: "llms.txt란 무엇이고 CitationEasy의 것은 어디에 있나요?",
    faqLlmsTxtA:
      "llms.txt는 브라우저가 아니라 언어 모델을 위해 작성된 사이트의 일반 텍스트 색인입니다. CitationEasy의 것은 /llms.txt에 있으며, 사이트의 모든 페이지를 빠짐없이 나열한 전체 버전은 /llms-full.txt에 있습니다.",
    faqMarkdownQ:
      "CitationEasy 페이지를 HTML 대신 마크다운으로 읽을 수 있나요?",
    faqMarkdownA:
      "네. 사이트 내 어떤 경로 앞에든 /md/를 붙이면 됩니다. 예를 들어 /md/citation-style/apa나 /md/tools/word-counter처럼요. 데이터 기반 페이지는 각 스타일 자체의 CSL 정의로 생성한 실제 서식 예시를 포함해 전체 내용을 반환합니다. 손으로 작성한 글 페이지(가이드, 치트시트 등)는 본문이 페이지 자체에 있으므로 요약 카드와 정식 HTML URL을 반환합니다.",
    faqReuseQ: "CitationEasy의 출력을 제 제품에 사용해도 되나요?",
    faqReuseA:
      "네. 서식이 적용된 인용은 자료에 관한 사실이므로 자유롭게 사용하셔도 됩니다. CSL 스타일 정의 자체는 Citation Style Language 프로젝트가 CC BY-SA 3.0으로 제공합니다. CitationEasy에 대한 출처 표기는 감사히 받겠지만 필수는 아닙니다.",
    missingHeading: "빠진 것이 있나요?",
    missingBody:
      "에이전트에 필요한 엔드포인트, 필드, 형식이 여기 없다면 [알려주세요](/contact). 직접 둘러보고 계신다면 [인용 생성기에서 시작하세요](/).",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle: "어떤 인용 스타일을 사용해야 할까? - 무료 스타일 퀴즈",
    metaDescription:
      "전공 분야, 논문 유형, 선호도에 대한 몇 가지 간단한 질문에 답하면 논문에 가장 적합한 인용 스타일을 찾아드립니다. APA, MLA, 시카고, 밴쿠버 등.",
    ogTitle: "어떤 인용 스타일을 사용해야 할까?",
    ogDescription: "무료 퀴즈로 논문에 가장 적합한 인용 스타일을 찾아보세요.",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "스타일 퀴즈",
    backLink: "← 생성기로 돌아가기",
    heading: "어떤 인용 스타일을 사용해야 할까?",
    intro:
      "몇 가지 간단한 질문에 답하면 논문에 가장 적합한 인용 스타일을 추천해 드립니다.",
    progress: "질문 {current} / {total}",
    qDiscipline: "전공 분야가 무엇인가요?",
    optSocialScience: "심리학·사회과학",
    optHumanities: "문학·인문학",
    optHistory: "역사학·미술사",
    optMedical: "의학·간호학·보건학",
    optEngineering: "공학·컴퓨터과학",
    optNaturalScience: "자연과학 (생물학, 화학)",
    optLaw: "법학",
    optBusiness: "경영학·경제학",
    qPaperType: "어떤 종류의 논문을 쓰고 계신가요?",
    optResearch: "연구 논문 또는 학위논문",
    optReview: "문헌 리뷰",
    optReport: "실험 보고서 또는 기술 보고서",
    optEssay: "에세이 또는 수업 과제",
    optJournal: "학술지 투고 논문",
    qRegion: "소속 기관은 어디에 있나요?",
    optUs: "미국",
    optUk: "영국·호주",
    optCanada: "캐나다",
    optEurope: "유럽 (영국 제외)",
    optOther: "기타",
    qPreference: "선호하는 인용 형식이 있나요?",
    optAuthorDate: "본문 내 인용 (저자, 연도)",
    optNumeric: "번호가 매겨진 참고문헌 [1]",
    optFootnotes: "각주",
    optNoPreference: "선호 없음",
    styleVancouver: "밴쿠버",
    styleAma: "AMA (미국의사협회)",
    styleIeee: "IEEE",
    styleBluebook: "블루북",
    styleCse: "CSE (과학편집자협의회)",
    styleChicagoNotes: "시카고 (주석·서지 방식)",
    styleMla: "MLA (9판)",
    styleApa: "APA (7판)",
    styleHarvard: "하버드",
    reasonVancouverMedical:
      "밴쿠버 스타일은 의학·보건과학 학술지의 표준으로, 번호가 매겨진 참고문헌을 사용합니다.",
    reasonAma:
      "AMA는 의학 학술지에서 널리 쓰이며 번호가 매겨진 인용을 사용합니다.",
    reasonIeee: "IEEE는 공학, 컴퓨터과학, IT 분야의 표준 인용 스타일입니다.",
    reasonBluebook:
      "블루북은 법률 문서 작성의 결정적인 인용 스타일입니다. 시카고 스타일이 이에 가장 가까운 범용 대안입니다.",
    reasonCse: "CSE는 생물학과 자연과학 분야의 표준입니다.",
    reasonChicagoHistory:
      "시카고 주석·서지 방식은 역사학과 미술사 분야의 정석으로, 각주를 사용해 인용합니다.",
    reasonChicagoHumanities:
      "시카고 주석·서지 방식은 각주 기반 접근 방식으로 인문학 분야에 잘 맞습니다.",
    reasonMla: "MLA는 문학, 어학, 인문학 분야의 표준입니다.",
    reasonApaBusiness:
      "APA는 경영학, 경제학, 경영 관리 분야에서 널리 쓰입니다.",
    reasonHarvard:
      "하버드 방식은 영국과 호주 대학에서 가장 흔히 쓰이는 스타일입니다.",
    reasonChicagoFootnotes:
      "시카고 주석·서지 방식은 각주를 사용해 상세한 인용에 적합합니다.",
    reasonVancouverNumeric:
      "밴쿠버 스타일은 번호가 매겨진 인용을 사용해 본문을 깔끔하고 읽기 쉽게 유지합니다.",
    reasonApaDefault:
      "APA는 사회과학, 교육학을 비롯한 다양한 분야에서 가장 널리 쓰이는 인용 스타일입니다.",
    recommendLabel: "추천 스타일",
    generateButton: "{style}로 인용 만들기",
    retakeButton: "다시 퀴즈 풀기",
    guidesLink: "더 알아보려면 인용 가이드를 확인하세요 →",
    previousButton: "← 이전 질문",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "CitationEasy 검색",
    metaDescription:
      "CitationEasy의 모든 페이지를 한 번에 검색하세요: {count}가지 인용 스타일, 250개 이상의 무료 도구, 가이드, 인용 방법 페이지, 스타일 비교, 변환기, 용어집까지.",
    keyword1: "인용 스타일 검색",
    keyword2: "인용 가이드 찾기",
    keyword3: "인용 도구 검색",
    ogDescription:
      "사이트의 모든 페이지를 한 번에 검색합니다 — 스타일, 도구, 가이드, 인용 방법 페이지, 비교, 변환기, 용어집 용어까지.",
    ogImageSubtitle:
      "모든 인용 스타일, 도구, 가이드, 인용 방법 페이지, 비교, 변환기, 용어집 용어를 한꺼번에 검색합니다.",
    ogKind: "검색",
    breadcrumb: "검색",
    heading: "CitationEasy 검색",
    intro:
      "사이트의 모든 인용 스타일, 도구, 가이드, 인용 방법 페이지, 비교, 변환기, 용어집 용어를 한꺼번에 검색합니다.",
    inputLabel: "검색어",
    inputPlaceholder: "예: APA로 팟캐스트 인용하기, 내어쓰기, DOI",
    submit: "검색",
    browseHeading: "또는 섹션별로 둘러보기",
    browseStyles: "인용 스타일",
    browseStylesNote: "{count}개 스타일",
    browseTools: "무료 도구",
    browseToolsNote: "{count}개 도구",
    browseHowTo: "모든 자료 인용 방법",
    browseHowToNote: "{count}개 페이지",
    browseGuides: "가이드",
    browseGuidesNote: "{count}개 가이드",
    browseGlossary: "용어집",
    browseGlossaryNote: "{count}개 용어",
    browseComparisons: "스타일 비교",
    browseComparisonsNote: "{count}개 비교",
    browseConverters: "변환기",
    browseConvertersNote: "{count}개 변환기",
    browseCheatSheets: "치트시트",
    browseCheatSheetsNote: "{count}개 시트",
    facetsLabel: "페이지 유형으로 필터링",
    facetAll: "전체 ({count})",
    noMatches: '"{query}"와(과) 일치하는 페이지가 없습니다.',
    matchesOne: '"{query}"와(과) 일치하는 페이지 {count}개를 찾았습니다.',
    matchesMany: '"{query}"와(과) 일치하는 페이지 {count}개를 찾았습니다.',
    pagerLabel: "결과 페이지",
    pagerPrevious: "← 이전",
    pagerNext: "다음 →",
    pagerPosition: "{total}페이지 중 {page}페이지",
    paletteLoading: "검색 중…",
    paletteError: "현재 검색을 사용할 수 없습니다. 다시 시도해 주세요.",
    paletteViewAll: "“{query}”의 모든 결과 보기",
    apiNote:
      "직접 무언가를 만들고 계신가요? 같은 인덱스를 [/api/v1/search](/api/v1/search?q=podcast)에서 JSON으로, 또는 MCP를 통해 이용할 수 있습니다. 자세한 내용은 [에이전트 문서](/ai)를 확인하세요.",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle:
      "이 페이지 인용하기 - 원클릭 인용 (북마클릿 & Chrome 확장 프로그램)",
    metaDescription:
      "어떤 웹페이지든 클릭 한 번으로 인용하세요. 무료 '이 페이지 인용하기' 북마클릿을 북마크 바에 드래그하거나, 툴바 버튼과 우클릭 인용 기능이 있는 무료 Chrome 확장 프로그램을 설치하세요. Chromebook과 제한된 브라우저에서도 작동합니다.",
    ogTitle: "이 페이지 인용하기 북마클릿 & Chrome 확장 프로그램",
    ogDescription:
      "어떤 페이지에서든 클릭 한 번으로 웹사이트를 인용하세요 — 드래그 앤 드롭 북마클릿과 우클릭 인용을 지원하는 무료 Chrome 확장 프로그램입니다.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: "이 페이지 인용하기 북마클릿",
    appName: "이 페이지 인용하기 북마클릿",
    appDescription:
      "지금 읽고 있는 웹페이지를 클릭 한 번으로 인용하는 무료 북마클릿입니다. 해당 페이지의 URL이 미리 입력된 상태로 CitationEasy를 열고, APA, MLA, 시카고를 비롯한 {count}가지 이상의 스타일로 인용을 서식화합니다.",
    breadcrumbLabel: "이동 경로",
    breadcrumbHome: "홈",
    breadcrumbCurrent: "이 페이지 인용하기 북마클릿",
    heading: "이 페이지 인용하기: 북마클릿 & Chrome 확장 프로그램",
    intro:
      "어떤 웹페이지든 클릭 한 번으로 인용하세요 — 가입도 필요 없습니다. 아래 북마클릿을 북마크 바로 드래그하거나(설치 전혀 불필요), 툴바 버튼과 우클릭 인용을 지원하는 무료 Chrome 확장 프로그램을 받으세요.",
    dragPrompt: "이 버튼을 북마크 바로 드래그하세요:",
    buttonTitle: "북마크 바로 드래그하세요",
    buttonLabel: "📑 이 페이지 인용하기",
    dontClick: "여기서는 클릭하지 마세요. 먼저 북마크 바로 드래그해야 합니다.",
    installHeading: "설치 방법",
    step1Title: "북마크 바 표시하기",
    step1Body:
      "대부분의 브라우저에서 Ctrl+Shift+B(Mac에서는 Cmd+Shift+B)를 누르면 북마크 바를 켜고 끌 수 있습니다. 버튼을 놓을 공간을 마련하세요.",
    step2Title: "버튼을 위로 드래그하기",
    step2Body:
      "아래의 '이 페이지 인용하기' 버튼을 클릭한 채로 북마크 바까지 드래그한 뒤 놓으세요. 일반 북마크로 등록됩니다.",
    step3Title: "어떤 페이지에서든 클릭하기",
    step3Body:
      "기사, 뉴스, 학술지 페이지를 읽는 동안 새로 추가한 북마크를 클릭하세요. 해당 페이지의 URL이 미리 입력된 상태로 CitationEasy가 열리고, 바로 복사할 수 있는 인용이 준비됩니다.",
    manualHeading: "드래그가 안 되나요? 직접 추가하세요",
    manualBody:
      '새 북마크를 만들고 이름을 "이 페이지 인용하기"로 지정한 다음, 다음 내용을 URL/주소로 붙여넣으세요:',
    howHeading: "작동 원리",
    howBody:
      "이 북마클릿은 현재 읽고 있는 페이지에서 어떤 코드도 실행하지 않습니다. 해당 페이지의 웹 주소만 CitationEasy로 전달하며, 저희 서버가 공개된 페이지 메타데이터를 가져와 분석합니다. 이는 URL을 직접 생성기에 붙여넣을 때와 동일한, 신뢰할 수 있는 방식입니다. 이 덕분에 안전하며, 예전의 페이지 내 북마클릿을 사용할 수 없게 만든 교차 출처 제한도 피할 수 있습니다.",
    extensionHeading: "Chrome 확장 프로그램을 선호하시나요?",
    extensionBody:
      "무료 CitationEasy 확장 프로그램을 사용하면 현재 탭을 인용하는 툴바 버튼과, 페이지를 열지 않고도 링크나 선택한 DOI·ISBN을 인용할 수 있는 우클릭 메뉴가 추가됩니다. 북마클릿과 마찬가지로 방문한 페이지에서 코드를 실행하지 않고 URL만 CitationEasy로 전달합니다. 필요한 권한은 `activeTab`과 `contextMenus`뿐이며, Chrome, Edge, Brave 등 Chromium 기반 브라우저에서 작동합니다.",
    downloadButton: "⬇ Chrome 확장 프로그램 다운로드 (.zip)",
    install1: "확장 프로그램을 다운로드해 압축을 해제하세요.",
    install2:
      "`chrome://extensions`를 열고 오른쪽 상단의 **개발자 모드**를 켜세요.",
    install3:
      "**압축해제된 확장 프로그램을 로드합니다**를 클릭하고 압축을 해제한 폴더를 선택하세요.",
    install4:
      "CitationEasy 버튼을 고정한 다음, 어떤 페이지에서든 클릭해 인용하세요.",
    faqHeading: "자주 묻는 질문",
    faqWhatQ: "'이 페이지 인용하기' 북마클릿이 무엇인가요?",
    faqWhatA:
      "브라우저의 북마크 바로 드래그해서 사용하는 작은 북마크입니다. 어떤 웹페이지에서든 클릭하면 해당 페이지의 URL이 미리 입력된 상태로 CitationEasy가 새 탭에서 열려, 복사·붙여넣기 없이 클릭 한 번으로 서식이 적용된 인용을 얻을 수 있습니다.",
    faqExtensionNeededQ: "확장 프로그램을 설치해야 하나요?",
    faqExtensionNeededA:
      "아니요. 북마클릿은 그저 북마크일 뿐이므로 설치할 것도, 허용할 권한도 없습니다. 확장 프로그램이 차단된 학교 Chromebook이나 대부분의 모바일 브라우저에서도 작동합니다. 확장 프로그램을 선호하신다면 이 페이지에서 무료 Chrome 확장 프로그램도 받을 수 있습니다.",
    faqChromeQ: "Chrome 확장 프로그램이 있나요?",
    faqChromeA:
      "네. 무료 CitationEasy Chrome 확장 프로그램을 사용하면 현재 탭을 인용하는 툴바 버튼과, 페이지를 열지 않고도 링크나 선택한 DOI/ISBN을 인용할 수 있는 우클릭 메뉴가 추가됩니다. 방문한 페이지에서 코드를 실행하지 않으며 필요한 권한은 activeTab과 contextMenus뿐입니다. 이 페이지에서 다운로드한 뒤 chrome://extensions에서 로드하세요. Chrome, Edge, Brave 등 Chromium 기반 브라우저에서 작동합니다.",
    faqAddQ: "북마클릿은 어떻게 추가하나요?",
    faqAddA:
      "먼저 북마크 바가 보이는지 확인한 다음, 이 페이지의 '이 페이지 인용하기' 버튼을 그 위로 드래그하세요. 드래그가 불가능한 경우(예: 모바일)에는 새 북마크를 직접 만들고 북마클릿 코드를 URL로 붙여넣으세요.",
    faqSafeQ: "안전한가요? 지금 보고 있는 페이지 내용을 읽나요?",
    faqSafeA:
      "네, 안전합니다. 이 북마클릿은 현재 읽고 있는 페이지에서 어떤 코드도 실행하지 않습니다. 해당 페이지의 웹 주소만 CitationEasy로 전달하며, 저희 서버가 공개된 페이지 메타데이터를 가져와 분석합니다. 이는 URL을 직접 붙여넣을 때와 정확히 동일한 방식입니다.",
    faqOtherSourcesQ: "웹사이트가 아닌 다른 자료에도 사용할 수 있나요?",
    faqOtherSourcesA:
      "이 북마클릿은 웹페이지용이지만, 그 안의 링크는 `?source=` 매개변수를 통해 DOI, ISBN, PMID, arXiv ID도 받을 수 있습니다. 따라서 공유 가능한 '이 자료 인용하기' 링크는 학술지 논문과 도서에도 사용할 수 있습니다.",
    relatedHeading: "관련 도구",
    relatedGenerator: "인용 생성기",
    relatedHowToCite: "웹사이트 인용 방법",
    relatedTools: "모든 도구",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle: "공유된 참고문헌 목록 - 공유된 인용 보기 및 가져오기",
    metaDescription:
      "다른 사람이 CitationEasy에서 공유한 참고문헌 목록을 엽니다. 서식이 적용된 인용을 확인하고 복사하거나, 목록 전체를 내 참고문헌 목록으로 가져올 수 있습니다. 무료이며 계정이 필요 없고, 데이터는 링크 자체에 담겨 있습니다.",
    ogTitle: "공유된 참고문헌 목록",
    ogDescription:
      "공유된 참고문헌 목록을 보고 가져올 수 있습니다. 인용은 링크 안에 담겨 있어 서버에는 아무것도 저장되지 않으며, 링크는 만료되지 않습니다.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "이동 경로",
    breadcrumbHome: "홈",
    breadcrumbCurrent: "공유된 참고문헌 목록",
    heading: "공유된 참고문헌 목록",
    intro:
      "누군가 이 인용 목록을 회원님과 공유했습니다. 복사하거나, 클릭 한 번으로 목록 전체를 회원님의 CitationEasy 참고문헌 목록으로 가져올 수 있습니다.",
    loading: "공유된 참고문헌 목록을 여는 중…",
    copyAll: "전체 복사",
    copied: "복사했습니다",
    copyFailed: "복사에 실패했습니다",
    citationOne: "건의 인용",
    citationMany: "건의 인용",
    addAll: "모두 내 참고문헌 목록에 추가",
    added: "{count}건을 참고문헌 목록에 추가했습니다",
    skippedOne: "중복된 {count}건을 건너뛰었습니다",
    skippedMany: "중복된 {count}건을 건너뛰었습니다",
    openGenerator: "생성기 열기",
    emptyHeading: "이 링크에는 공유된 참고문헌 목록이 없습니다",
    emptyBody:
      "이 페이지는 CitationEasy에서 공유된 참고문헌 목록을 표시합니다. 회원님의 목록을 공유하려면 [인용 생성기](/)에서 참고문헌 목록을 열고 **'내보내기 → 공유 링크 복사'**를 선택한 뒤, 원하는 상대에게 링크를 보내세요. 인용은 링크 자체에 담겨 있어 서버에는 아무것도 저장되지 않으므로, 링크는 언제까지나 작동하며 데이터도 비공개로 유지됩니다.",
    decodeError: "이 공유 링크를 열 수 없습니다.",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "도서",
    bookLower: "도서",
    bookChapter: "도서의 장",
    bookChapterLower: "도서의 장",
    case: "판례",
    caseLower: "판례",
    conferencePaper: "학술대회 논문",
    conferencePaperLower: "학술대회 논문",
    courtCase: "법원 판례",
    courtCaseLower: "법원 판례",
    federalStatute: "연방법",
    federalStatuteLower: "연방법",
    governmentDocument: "정부 문서",
    governmentDocumentLower: "정부 문서",
    governmentReport: "정부 보고서",
    governmentReportLower: "정부 보고서",
    journalArticle: "학술지 논문",
    journalArticleLower: "학술지 논문",
    lawReviewArticle: "법률 학술지 논문",
    lawReviewArticleLower: "법률 학술지 논문",
    legislation: "법령",
    legislationLower: "법령",
    newspaperArticle: "신문 기사",
    newspaperArticleLower: "신문 기사",
    patent: "특허",
    patentLower: "특허",
    podcast: "팟캐스트",
    podcastLower: "팟캐스트",
    preprint: "프리프린트",
    preprintLower: "프리프린트",
    standard: "표준 규격",
    standardLower: "표준 규격",
    thesis: "학위논문",
    thesisLower: "학위논문",
    website: "웹사이트",
    websiteLower: "웹사이트",
    youtubeVideo: "유튜브 동영상",
    youtubeVideoLower: "유튜브 동영상",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "{style}로 돌아가기",
    backToGenerator: "인용 생성기로 돌아가기",
    ctaHeading: "{style} 인용 자동으로 만들기",
    ctaButton: "지금 {style}로 인용하기 →",
    faqHeading: "자주 묻는 질문",
    resourcesHeading: "추가 자료",
    relatedHeading: "관련 {style} 가이드",
    resourceGenerator: "무료 인용 생성기 ({count}개 스타일)",
    resourceTools: "무료 글쓰기 도구",
    resourceGuides: "모든 인용 가이드",
    resourceStyleGenerator: "{style} 인용 생성기",
    resourceExamples: "{style} 인용 예시",
    resourceFormat: "{style} 서식 가이드",
    resourceInText: "{style} 본문 내 인용 가이드",
    resourceAnnotatedBib: "{style} 주석 참고문헌 목록 가이드",
    resourceReferencePage: "{style} {list} 가이드",
    notFoundTitle: "페이지를 찾을 수 없습니다",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "{style} 인용 예시 - 모든 자료 유형 [2026]",
    metaDescription:
      "도서, 학술지 논문, 웹사이트 등 {style}({edition}) 형식으로 서식이 적용된 인용 예시를 확인하세요. 바로 복사해 쓸 수 있는 {list} 항목과 본문 내 인용을 함께 제공합니다.",
    ogTitle: "{style} 인용 예시",
    ogDescription:
      "흔한 자료 유형마다 바로 복사해 쓸 수 있는 {style} 항목입니다.",
    ogImageTitle: "{style} 인용 예시",
    ogKind: "{style} {edition}",
    keywordExamples: "{style} 인용 예시",
    keywordReference: "{style} 참고문헌 예시",
    keywordInText: "{style} 본문 내 인용 예시",
    keywordList: "{style} {listLower} 예시",
    keywordHowTo: "{style}에서 인용하는 방법",
    breadcrumb: "{style} 인용 예시",
    heading: "{style} 인용 예시",
    lead: "흔히 쓰이는 자료 유형 {count}가지에 대해 올바르게 서식이 적용된 {style}({edition}) 인용 예시를 확인하세요. 각 예시에는 {listLower} 항목과 그에 대응하는 본문 내 인용이 함께 제공됩니다.",
    entryLabel: "{list} 항목:",
    inTextLabel: "본문 내 인용:",
    ctaBody:
      "수작업 서식 적용은 이제 그만. DOI, URL, ISBN을 CitationEasy에 붙여넣으면 몇 초 만에 정확히 서식이 적용된 {style} 인용을 얻을 수 있습니다.",
    faqLookQ: "{style} 인용은 어떤 모습인가요?",
    faqLookA:
      "{style} 인용은 자료 정보를 모두 담은 {listLower} 항목과 본문 내 인용으로 구성됩니다. 형식은 자료 유형에 따라 달라집니다. 예를 들어 {style}({edition})의 도서 인용에는 저자, 연도, 제목, 출판사가 포함됩니다.",
    faqHowManyQ: "{style} 인용 예시는 몇 가지나 제공되나요?",
    faqHowManyA:
      "CitationEasy는 {types}를 포함해 {count}가지 자료 유형에 대한 {style} 인용 예시를 제공합니다. 각 예시에는 {listLower} 항목과 그에 대응하는 본문 내 인용이 함께 제공됩니다.",
    faqCopyQ: "이 {style} 인용 예시를 복사해서 써도 되나요?",
    faqCopyA:
      "네, 이 페이지의 {style} 예시는 각 자료 유형의 정확한 서식을 보여줍니다. 회원님의 인용을 위한 템플릿으로 그대로 사용하실 수 있습니다. 자동으로 서식을 적용하려면 무료 {style} 인용 생성기를 이용하세요.",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle: "{style} 서식 가이드 - 논문 서식 규칙 [2026]",
    metaDescription:
      "{style}({edition}) 논문 서식 완벽 가이드. 올바른 글꼴, 여백, 줄 간격, 표지, 머리글, {listLower} 서식 규칙을 알아보세요.",
    ogTitle: "{style} 논문 서식",
    ogDescription: "{style} 논문의 여백, 글꼴, 줄 간격, 표지를 안내합니다.",
    ogImageTitle: "{style} 논문 서식",
    ogImageSubtitle: "여백 {margins} · {spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "{style} 서식",
    keywordPaperFormat: "{style} 논문 서식",
    keywordRules: "{style} 서식 규칙",
    keywordMargins: "{style} 여백 글꼴 줄 간격",
    keywordList: "{style} {listLower} 서식",
    breadcrumb: "{style} 서식 가이드",
    heading: "{style} 서식 가이드",
    lead: "문서가 요구 기준을 충족하도록 다음 {style}({edition}) 논문 서식 규칙을 따르세요. 이 가이드는 글꼴, 여백, 줄 간격, 표지, 머리글, {listLower} 서식을 다룹니다.",
    paperHeading: "논문 서식",
    paperIntro:
      "다음은 {style}({edition}) 스타일로 작성된 논문의 핵심 서식 요건입니다.",
    labelFont: "글꼴",
    labelFontSize: "글꼴 크기",
    labelMargins: "여백",
    labelSpacing: "줄 간격",
    labelTitlePage: "표지",
    labelHeaders: "머리글·페이지 번호",
    listHeading: "{list} 서식",
    listIntro:
      "{style} 스타일에서 올바르게 서식이 적용되려면 {listLower}가 다음 규칙을 따라야 합니다:",
    ctaBody:
      "서식 적용은 CitationEasy에 맡기세요. DOI, URL, ISBN을 붙여넣으면 몇 초 만에 정확히 서식이 적용된 {style} 인용을 얻을 수 있습니다.",
    faqFontQ: "{style} 서식에는 어떤 글꼴과 크기를 사용해야 하나요?",
    faqFontA:
      "{style}({edition})은 {font}을(를) 요구합니다. 표준 글꼴 크기는 {fontSize}입니다.",
    faqMarginsQ: "{style}의 여백 요건은 무엇인가요?",
    faqMarginsA:
      "{style} 논문은 {margins}이 필요합니다. 이는 모든 페이지의 상하좌우 여백에 적용됩니다.",
    faqTitlePageQ: "{style}에는 표지가 필요한가요?",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle: "{style} 본문 내 인용 가이드 - 규칙과 예시 [2026]",
    metaDescription:
      "{style}({edition}) 본문 내 인용 서식을 알아보세요. 저자 1인, 저자 다수, 직접 인용, 저자 없음, 연도 없음의 규칙을 예시와 함께 소개합니다.",
    ogTitle: "{style} 본문 내 인용",
    ogDescription: "모든 {style} 본문 내 인용 형식을 예시와 함께 소개합니다.",
    ogImageTitle: "{style} 본문 내 인용",
    ogImageSubtitle: "저자 1인 {singleAuthor} · 저자 3인 이상 {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "{style} 본문 내 인용",
    keywordExamples: "{style} 본문 내 인용 예시",
    keywordParenthetical: "{style} 괄호 인용",
    keywordRules: "{style} 인용 규칙",
    keywordHowTo: "{style} 본문 내 인용 방법",
    breadcrumb: "{style} 본문 내 인용",
    heading: "{style} 본문 내 인용",
    lead: "이 완벽 가이드로 {style}({edition}) 본문 내 인용을 마스터하세요. 저자 1인과 저자 다수, 직접 인용, 정보가 누락된 자료 등 모든 상황에서의 올바른 형식을 알아봅니다.",
    rulesHeading: "본문 내 인용 규칙",
    rulesIntro:
      "다음은 논문을 쓸 때 흔히 마주치는 상황별 {style} 본문 내 인용 규칙입니다.",
    labelSingleAuthor: "저자 1인",
    labelTwoAuthors: "저자 2인",
    labelThreeOrMore: "저자 3인 이상",
    labelDirectQuote: "직접 인용",
    labelNoAuthor: "저자 없음",
    labelNoDate: "연도 없음",
    examplesHeading: "간단한 예시",
    examplesIntro:
      "다양한 자료 유형에 대한 실제 {style} 본문 내 인용 예시입니다:",
    ctaBody:
      "본문 내 인용 서식 걱정은 이제 그만하세요. DOI, URL, ISBN을 CitationEasy에 붙여넣으면 {listLower} 항목과 본문 내 인용을 즉시 얻을 수 있습니다.",
    faqFormatQ: "{style} 본문 내 인용은 어떻게 서식을 적용하나요?",
    faqFormatA:
      "{style}에서 저자가 1인일 때는 {singleAuthor} 형식을 사용합니다. 저자가 2인일 때는 {twoAuthors}를, 저자가 3인 이상일 때는 {threeOrMore}를 사용합니다.",
    faqQuoteQ: "{style}에서 직접 인용은 어떻게 표기하나요?",
    faqQuoteA:
      "{style}({edition})에서 직접 인용을 표기할 때는 다음 형식을 사용합니다: {directQuote}.",
    faqMissingQ: "{style}에서 저자나 발행일이 없으면 어떻게 하나요?",
    faqMissingA:
      "{style}에서 저자가 없을 때는 {noAuthor}를 사용합니다. 발행일이 없을 때는 {noDate}를 사용합니다.",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "{style} {list} 가이드 - 서식 규칙 [2026]",
    metaDescription:
      "{style} {listLower}({edition})의 서식을 알아보세요. {fullName}을 위한 단계별 서식 규칙, 예시, 피해야 할 흔한 실수를 소개합니다.",
    ogTitle: "{style} {listLower}",
    ogDescription: "{style}에서 {list} 작성하는 방법.",
    ogImageTitle: "{style} {list}",
    ogKind: "{style} {edition}",
    breadcrumb: "{style} {list} 작성법",
    heading: "{style} {list} 작성법",
    lead: "{listLower}는 {style}({edition}) 형식으로 작성된 학술 논문에서 가장 중요한 부분 중 하나입니다. 본문에서 인용한 모든 자료의 상세 정보를 독자에게 제공하여, 참고 자료를 찾고 검증할 수 있게 해줍니다. 올바른 서식은 학문적 신뢰성을 위해 필수적입니다. 이 가이드는 정확한 규칙을 안내하고, 실제 예시를 보여주며, 학생들이 가장 흔히 저지르는 실수를 짚어드립니다.",
    rulesHeading: "서식 규칙",
    rulesIntro: "{style} {listLower}를 작성할 때는 다음 규칙을 따르세요:",
    exampleHeading: "{list} 예시",
    exampleIntro:
      "다양한 자료 유형의 항목이 포함된 {style} {listLower}의 모습입니다:",
    mistakesHeading: "피해야 할 흔한 실수",
    mistakesIntro:
      "학생들이 {style} {listLower}를 작성할 때 가장 자주 저지르는 다섯 가지 서식 오류입니다:",
    mistakeIndent:
      "**내어쓰기 누락 또는 오류:** 모든 항목은 첫 줄을 왼쪽에 맞추고, 이후 줄은 0.5인치(약 1.27cm) 들여써야 합니다. Tab 키를 누르는 대신 워드프로세서의 문단 설정을 사용하세요.",
    mistakeOrder:
      '**알파벳순 또는 정렬 순서 오류:** 항목은 {style} 규칙에 따라 배열해야 합니다. 알파벳순으로 정렬할 때는 "A", "An", "The" 같은 관사는 무시합니다. 번호 방식 스타일에서는 본문에 처음 등장한 순서대로 항목을 나열합니다.',
    mistakeSpacing:
      "**줄 간격 불일치:** {listLower} 전체에서 줄 간격이 일정한지 다시 확인하세요. 한 줄 간격과 두 줄 간격이 섞이는 것은 흔하지만 놓치기 쉬운 실수입니다.",
    mistakeItalics:
      "**기울임꼴 오용:** 도서나 학술지처럼 독립적으로 발행되는 작품의 제목은 기울임꼴로 표기하지만, 논문이나 장의 제목은 기울임꼴로 표기하지 않습니다. 어떤 요소를 기울임꼴로 표기해야 하는지는 {style} 지침에서 정확히 확인하세요.",
    mistakeLinks:
      "**DOI 및 URL 누락 또는 깨짐:** DOI가 있는 경우 반드시 클릭 가능한 링크 형태로 포함하세요. 논문을 제출하기 전에 모든 URL이 올바른 자료로 연결되는지 확인하세요.",
    ctaHeading: "{list} 자동으로 만들기",
    ctaBody:
      "수작업 서식 적용은 이제 그만. DOI, URL, ISBN을 CitationEasy에 붙여넣으면 몇 초 만에 정확히 서식이 적용된 {style} 인용을 얻어 바로 {listLower}에 사용할 수 있습니다.",
    faqWhatQ: "{style} {list}란 무엇인가요?",
    faqWhatA:
      "{style} {list}는 논문 끝부분에서 본문에 인용한 모든 자료를 {fullName}({edition}) 지침에 따라 나열하는 부분입니다. 독자가 참고한 각 자료를 찾고 검증할 수 있게 해줍니다.",
    faqFormatQ: "{style} {listLower}는 어떻게 서식을 적용하나요?",
    faqFormatA:
      '새 페이지에서 시작해 제목을 "{list}"로 하고, 논문에서 인용한 모든 자료를 나열하세요. 내어쓰기, 줄 간격, 알파벳순 또는 번호 순서, 기울임꼴에 대해 {style}의 구체적인 규칙을 따르세요.',
    faqDifferenceQ: "{listLower}와 서지 목록의 차이는 무엇인가요?",
    faqDifferenceA:
      '{listLower}에는 논문에서 직접 인용한 자료만 포함되지만, 서지 목록에는 참고했지만 인용하지 않은 자료도 포함될 수 있습니다. {style}({edition})에서는 논문 끝부분의 목록을 "{list}"라고 부릅니다.',
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle: "{style} 주석 참고문헌 목록 가이드와 예시 [2026]",
    metaDescription:
      "{style}({edition})로 주석 참고문헌 목록을 작성하는 방법을 알아보세요. {fullName} 주석 참고문헌 목록을 위한 서식 규칙, 예시 항목, 팁을 소개합니다.",
    ogTitle: "{style} 주석 참고문헌 목록",
    ogDescription: "{style}에서 주석 참고문헌 목록의 서식을 적용하는 방법.",
    ogImageTitle: "{style} 주석 참고문헌 목록",
    ogKind: "{style} {edition}",
    breadcrumb: "{style} 주석 참고문헌 목록",
    heading: "{style} 주석 참고문헌 목록",
    lead: "주석 참고문헌 목록은 각 인용마다 짧은 설명 또는 평가 문단이 함께 실린 자료 인용 목록입니다. {style} 형식({edition})에서는 각 항목이 올바르게 서식이 적용된 참고문헌으로 시작한 뒤, 자료를 요약·평가·고찰하는 주석이 이어집니다. 이 가이드는 완성도 높은 {style} 주석 참고문헌 목록을 만드는 데 필요한 규칙, 서식, 예시를 차례로 안내합니다.",
    whatHeading: "주석 참고문헌 목록이란?",
    whatBody:
      "주석 참고문헌 목록은 일반적인 {listLower}에 각 인용 뒤에 짧은 문단을 덧붙인 것입니다. 이 주석은 독자에게 자료의 내용, 질, 관련성에 대한 통찰을 제공합니다. 교수자는 학생들이 자료를 비판적으로 평가하고, 각 자료가 연구 주제에 어떻게 기여하는지 보여주도록 돕기 위해 주석 참고문헌 목록 과제를 자주 냅니다.",
    whatTypes:
      "주석에는 흔히 세 가지 유형이 있습니다. 자료를 요약하는 **서술형** 주석, 자료의 질과 신뢰성을 평가하는 **평가형** 주석, 그리고 두 가지를 모두 포함하는 **혼합형** 주석입니다. 과제 지침에서 어떤 유형을 사용할지 명시하고 있을 것입니다.",
    rulesHeading: "{style} 주석 참고문헌 목록 규칙",
    rulesIntro:
      "{fullName}에서 주석 참고문헌 목록의 서식을 적용할 때는 다음 규칙을 따르세요:",
    exampleHeading: "주석 참고문헌 목록 항목 예시",
    exampleIntro:
      "다음은 {sourceType}에 대한 {style} 주석 참고문헌 목록 항목의 예시입니다:",
    exampleAnnotation:
      "이 자료는 실증적 근거로 뒷받침된 설득력 있는 주장을 제시하며 주제에 대한 포괄적인 개요를 제공한다. 저자는 폭넓은 1차·2차 자료를 활용해 설득력 있는 논지를 구축한다. 연구 방법은 엄격하며 결과도 명확하게 제시되어 있어, 이 주제를 이해하는 데 유용한 자료가 된다. 이 자료는 특히 연구 프로젝트의 이론적 틀을 세우는 데 유용하며, 참고문헌 목록에 포함된 다른 자료들을 보완하는 관점을 제공한다.",
    tipsHeading: "{style} 주석 작성 팁",
    tipSummarize:
      "먼저 자료를 두세 문장으로 요약한 다음, 그 장점, 한계, 관련성에 대한 평가를 덧붙이세요.",
    tipTone:
      "주석 전체에서 3인칭과 학술적인 어조를 사용하세요. 교수자가 요청하지 않는 한, 캐주얼한 표현이나 1인칭 소감은 피하세요.",
    tipLength:
      "각 주석은 100~200단어 사이로 작성하세요. 간결하게, 자료의 가장 중요한 부분에 집중하세요.",
    tipRelevance:
      "그 자료가 전체 연구에 어떻게 부합하는지 설명하세요. 어떤 독자적인 관점이나 근거를 제공하는지 서술하세요.",
    tipCitation:
      "주석을 작성하기 전에 각 항목의 인용 부분이 {fullName} 서식 규칙을 정확히 따르는지 확인하세요.",
    ctaHeading: "주석 참고문헌 목록 자동으로 만들기",
    ctaBody:
      "CitationEasy의 주석 참고문헌 목록 작성 도구로 올바르게 서식이 적용된 {style} 인용을 만든 다음, 주석을 추가하세요.",
    ctaButton: "주석 참고문헌 목록 작성 도구 열기 →",
    faqWhatQ: "{style}에서 주석 참고문헌 목록이란 무엇인가요?",
    faqWhatA:
      "{style}({edition})의 주석 참고문헌 목록은 {fullName} 스타일로 서식이 적용된 인용 목록으로, 각 인용 뒤에는 자료를 요약·평가·고찰하는 짧은 문단이 이어집니다. 독자가 각 자료의 관련성과 질을 이해하는 데 도움을 줍니다.",
    faqLengthQ: "주석은 얼마나 길게 써야 하나요?",
    faqLengthA:
      "주석은 보통 100~200단어입니다. 요구되는 분석의 깊이에 따라 더 짧거나 긴 주석이 필요한 과제도 있습니다. 구체적인 분량 요건은 항상 교수자의 지침을 확인하세요.",
    faqIncludeQ: "주석에는 무엇을 포함해야 하나요?",
    faqIncludeA:
      "주석에는 자료의 핵심 주장이나 발견에 대한 간단한 요약, 자료의 신뢰성과 유용성에 대한 평가, 그리고 그 자료가 연구에 어떻게 부합하는지에 대한 고찰이 포함되어야 합니다. 순전히 서술적인 주석도 있고, 비판적 분석을 포함하는 주석도 있습니다.",
  },

  guidePage: {
    byline: "작성: {author}",
    published: "게시: {date}",
    updated: "수정: {date}",
    readingTime: "other:읽는 시간 {count}분",
    wordCount: "other:{count}단어",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "가이드 라이브러리",
    browseByCategory: "카테고리별 보기",
    recentlyUpdated: "최근 업데이트",
    allGuides: "모든 가이드",
    guideCount: "other:가이드 {count}개",
    updatedOn: "{date} 업데이트",
    minRead: "other:{count}분 소요",
    onThisPage: "이 페이지의 내용",
    viewAllInCategory: "{category} 가이드 전체 보기",
    moreInCategory: "{category}의 다른 가이드",
    aboutThisGuide: "이 가이드 정보",
    provenance: "작성: {author}. {published} 게시, 최종 업데이트 {updated}.",
    categoryIntroSuffix:
      "모든 가이드는 무료이며 학생과 연구자를 위해 작성되었고, 마지막으로 검토된 시점을 알 수 있도록 날짜가 표시됩니다.",
    photoCredit: "사진: {author}, {source} ({license})",
    imageAlt: "{category} 가이드를 나타내는 사진",
    imageSourceCommons: "위키미디어 공용",
    apaStyleName: "APA 스타일",
    apaStyleDescription:
      "APA 7판으로 웹사이트, 학술지 논문, 도서, 동영상 등을 인용하는 방법. 각각 참고문헌 목록과 본문 내 인용 예시 포함.",
    mlaStyleName: "MLA 스타일",
    mlaStyleDescription:
      "웹 페이지와 논문부터 시, 희곡, 영화, 강의 자료까지 모든 일반 자료를 MLA 9판으로 인용하는 방법.",
    chicagoStyleName: "시카고 스타일",
    chicagoStyleDescription:
      "도서, 논문, 기록물, 정부 문서, 미디어의 주석-참고문헌 방식과 저자-연도 방식을 다루는 시카고 매뉴얼 가이드.",
    styleComparisonsName: "스타일 비교",
    styleComparisonsDescription:
      "APA, MLA, 시카고, 하버드, 밴쿠버, IEEE 등을 나란히 비교하고 전공별로 요구되는 스타일을 안내합니다.",
    researchMethodsName: "연구 방법",
    researchMethodsDescription:
      "연구 논문 계획, 문헌 검토, 노트 작성, 자료 평가, 표절 방지, 참고문헌 목록 작성 방법.",
    academicWritingName: "학술 글쓰기",
    academicWritingDescription:
      "초록, 서론, 결론, 논지문, 연구 방법 섹션, 명확한 학술 문장을 위한 글쓰기 가이드.",
    fieldSpecificName: "분야별",
    fieldSpecificDescription:
      "심리학, 역사학, 문학부터 의학, 공학, 법학, 간호학까지 개별 학문 분야를 위한 인용 가이드.",
    sourceEvaluationName: "자료 평가",
    sourceEvaluationDescription:
      "신뢰성 판단, 학술 자료와 대중 자료 구분, Google 학술검색과 도서관 데이터베이스 활용, 편향 식별 방법.",
    citationHelpName: "인용 도움말",
    citationHelpDescription:
      "까다로운 사례에 대한 답: 저자나 날짜 없음, 다수 저자, PDF, AI 도구, 판례, 인용 가져오기와 내보내기.",
  },

  common: {
    backToGuides: "← 가이드 목록으로 돌아가기",
    free: "무료",
    noSignup: "가입 불필요",
    backToHome: "인용 생성기로 돌아가기",
    inEnglish: "영어로",
    viewInEnglish: "영어로 보기",
    availableInEnglish: "이 페이지는 영어판에서 더 자세히 볼 수 있습니다.",
    otherLanguages: "다른 언어",
    skipToContent: "본문으로 건너뛰기",
    cookieNotice:
      "CitationEasy를 무료로 유지하기 위해 분석 및 광고 목적의 쿠키를 사용합니다.",
    privacyPolicy: "개인정보처리방침",
    accept: "동의",
    decline: "거부",
    advertisement: "광고",
  },
  legalPage: {
    backLink: "← 생성기로 돌아가기",
    effective: "발효일:",
    updated: "최종 업데이트:",
  },
};

export default ko;
